<template>
  <div class="huananForecast">
    <div id="Legend">
      <table
        class="leaflet-control-legend leaflet-control"
        style="width: 235px;background: rgba(47,68,95, 0.9);"
      >
        <tbody class="">
          <tr class="">
            <td class="leaflet-control-legend-top-left"></td>
            <td class="leaflet-control-legend-top-center" align="right">
              <div class="leaflet-control-legend-title" align="left">
                预报机构
              </div>
              <div class="leaflet-control-legend-title-down"></div>
            </td>
            <td class="leaflet-control-legend-top-right"></td>
          </tr>
          <tr class="">
            <td class="leaflet-control-legend-mid-left"></td>
            <td
              class="leaflet-control-legend-mid-center"
              style="display: block;"
            >
              <table class="typhoon-legend-main">
                <tbody>
                  <tr>
                    <td>
                      <div style="float:left">
                        <input
                          type="checkbox"
                          class="typhoon-legend-input"
                          name="typhoon-legend"
                          value="中国"
                          id="China"
                          checked=""
                          @click="addForcastData(clickPoint)"
                        />
                        <div class="typhoon-legend-name">中国</div>
                      </div>
                    </td>
                    <td>
                      <div class="typhoon-legend-command" style="color:#FF6450">
                        ━ ━
                      </div>
                    </td>
                    <td>
                      <div style="float:left">
                        <input
                          type="checkbox"
                          class="typhoon-legend-input"
                          name="typhoon-legend"
                          value="中国香港"
                          id="HongKong"
                          checked=""
                          @click="addForcastData(clickPoint)"
                        />
                        <div class="typhoon-legend-name">中国香港</div>
                      </div>
                    </td>
                    <td>
                      <div class="typhoon-legend-command" style="color:#FF66FF">
                        ━ ━
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div style="float:left">
                        <input
                          type="checkbox"
                          class="typhoon-legend-input"
                          name="typhoon-legend"
                          value="日本"
                          id="Japan"
                          checked=""
                          @click="addForcastData(clickPoint)"
                        />
                        <div class="typhoon-legend-name">日本</div>
                      </div>
                    </td>
                    <td>
                      <div class="typhoon-legend-command" style="color:#43FF4B">
                        ━ ━
                      </div>
                    </td>
                    <td>
                      <div style="float:left">
                        <input
                          type="checkbox"
                          class="typhoon-legend-input"
                          name="typhoon-legend"
                          value="中国台湾"
                          id="Taiwan"
                          checked=""
                          @click="addForcastData(clickPoint)"
                        />
                        <div class="typhoon-legend-name">中国台湾</div>
                      </div>
                    </td>
                    <td>
                      <div class="typhoon-legend-command" style="color:#FFA040">
                        ━ ━
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div style="float:left">
                        <input
                          type="checkbox"
                          class="typhoon-legend-input"
                          name="typhoon-legend"
                          value="美国"
                          id="USA"
                          checked=""
                          @click="addForcastData(clickPoint)"
                        />
                        <div class="typhoon-legend-name">美国</div>
                      </div>
                    </td>
                    <td>
                      <div class="typhoon-legend-command" style="color:#40DDFF">
                        ━ ━
                      </div>
                    </td>
                    <td>
                      <div style="float:left">
                        <input
                          type="checkbox"
                          class="typhoon-legend-input"
                          name="typhoon-legend"
                          value="韩国"
                          id="korea"
                          checked=""
                          @click="addForcastData(clickPoint)"
                        />
                        <div class="typhoon-legend-name">韩国</div>
                      </div>
                    </td>
                    <td>
                      <div class="typhoon-legend-command" style="color:#669999">
                        ━ ━
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div style="float:left">
                        <input
                          type="checkbox"
                          class="typhoon-legend-input"
                          name="typhoon-legend"
                          value="欧洲"
                          id="Europe"
                          checked=""
                          @click="addForcastData(clickPoint)"
                        />
                        <div class="typhoon-legend-name">欧洲</div>
                      </div>
                    </td>
                    <td>
                      <div class="typhoon-legend-command" style="color:#373591">
                        ━ ━
                      </div>
                    </td>
                    <td>
                      <div style="float:left">
                        <input
                          type="checkbox"
                          class="typhoon-legend-input"
                          name="typhoon-legend"
                          value="中大预报"
                          id="zhongda"
                          checked=""
                          @click="addForcastData(clickPoint)"
                        />
                        <div class="typhoon-legend-name">中大预报</div>
                      </div>
                    </td>
                    <td>
                      <div class="typhoon-legend-command" style="color:#FF0000">
                        ━ ━
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td
              class="leaflet-control-legend-mid-center-hid"
              style="display: none;"
            ></td>
            <td class="leaflet-control-legend-mid-right"></td>
          </tr>
          <tr class="">
            <td class="leaflet-control-legend-foot-left"></td>
            <td class="leaflet-control-legend-foot-center"></td>
            <td class="leaflet-control-legend-foot-right"></td>
          </tr>
        </tbody>
      </table>
      <table
        class="leaflet-control-legend leaflet-control"
        style="width: 235px;background: rgba(47,68,95, 0.9);"
      >
        <tbody class="">
          <tr class="">
            <td class="leaflet-control-legend-top-left"></td>
            <td class="leaflet-control-legend-top-center" align="right">
              <div class="leaflet-control-legend-title" align="left">
                台风图例
              </div>
              <div class="leaflet-control-legend-title-down"></div>
            </td>
            <td class="leaflet-control-legend-top-right"></td>
          </tr>
          <tr class="">
            <td class="leaflet-control-legend-mid-left"></td>
            <td
              class="leaflet-control-legend-mid-center"
              style="display: block;"
            >
              <div class="typhoon-maplegend-main">
                <div class="typhoon-maplegend-child">
                  <svg width="100%" height="100%">
                    <circle
                      xmlns="http://www.w3.org/2000/svg"
                      cx="6"
                      cy="6"
                      r="5"
                      stroke="black"
                      stroke-width="1"
                      stroke-opacity="0.8"
                      fill-opacity="1"
                      fill="#008D00"
                    ></circle>
                  </svg>
                </div>
                <div class="typhoon-maplegend-text">
                  热带低压
                </div>
                <div class="typhoon-maplegend-child">
                  <svg width="100%" height="100%">
                    <circle
                      xmlns="http://www.w3.org/2000/svg"
                      cx="6"
                      cy="6"
                      r="5"
                      stroke="black"
                      stroke-width="1"
                      stroke-opacity="0.8"
                      fill-opacity="1"
                      fill="#4097EF"
                    ></circle>
                  </svg>
                </div>
                <div class="typhoon-maplegend-text">
                  热带风暴
                </div>
                <div style="clear:both"></div>
                <div class="typhoon-maplegend-child">
                  <svg width="100%" height="100%">
                    <circle
                      xmlns="http://www.w3.org/2000/svg"
                      cx="6"
                      cy="6"
                      r="5"
                      stroke="black"
                      stroke-width="1"
                      stroke-opacity="0.8"
                      fill-opacity="1"
                      fill="#FFFF00"
                    ></circle>
                  </svg>
                </div>
                <div class="typhoon-maplegend-text">
                  强热带风暴
                </div>
                <div class="typhoon-maplegend-child">
                  <svg width="100%" height="100%">
                    <circle
                      xmlns="http://www.w3.org/2000/svg"
                      cx="6"
                      cy="6"
                      r="5"
                      stroke="black"
                      stroke-width="1"
                      stroke-opacity="0.8"
                      fill-opacity="1"
                      fill="#FF7500"
                    ></circle>
                  </svg>
                </div>
                <div class="typhoon-maplegend-text">
                  台风
                </div>
                <div style="clear:both"></div>
                <div class="typhoon-maplegend-child">
                  <svg width="100%" height="100%">
                    <circle
                      xmlns="http://www.w3.org/2000/svg"
                      cx="6"
                      cy="6"
                      r="5"
                      stroke="black"
                      stroke-width="1"
                      stroke-opacity="0.8"
                      fill-opacity="1"
                      fill="#FF00FF"
                    ></circle>
                  </svg>
                </div>
                <div class="typhoon-maplegend-text">
                  强台风
                </div>
                <div class="typhoon-maplegend-child">
                  <svg width="100%" height="100%">
                    <circle
                      xmlns="http://www.w3.org/2000/svg"
                      cx="6"
                      cy="6"
                      r="5"
                      stroke="black"
                      stroke-width="1"
                      stroke-opacity="0.8"
                      fill-opacity="1"
                      fill="#DB0000"
                    ></circle>
                  </svg>
                </div>
                <div class="typhoon-maplegend-text">
                  超强台风
                </div>
                <div style="clear:both"></div>
              </div>
            </td>
            <td
              class="leaflet-control-legend-mid-center-hid"
              style="display: none;"
            ></td>
            <td class="leaflet-control-legend-mid-right"></td>
          </tr>
          <tr class="">
            <td class="leaflet-control-legend-foot-left"></td>
            <td class="leaflet-control-legend-foot-center"></td>
            <td class="leaflet-control-legend-foot-right"></td>
          </tr>
        </tbody>
      </table>
    </div>
    <Icon
      type="ios-arrow-dropdown-circle"
      @click="modal2 = true"
      v-show="modal2 == false"
      style="position: absolute;top: 98px;right: 30px;color: black;font-size: 33px;z-index: 999"
    />
    <Modal v-model="modal2" width="455" class-name="modal-right-top" :mask="false">
      <div slot="header" style="height: 15px">
        <span>操作面板</span>
        <Checkbox
          v-model="hangxian"
          @on-change="hangxianChange"
          style="margin-left: 158px;"
          >航线</Checkbox
        >
        <Select v-model="hangxianSelect" style="width:100px" size="small" @on-change="changeHangxian">
            <Option v-for="item in hangxianList" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
      </div>
      <Tabs :value="operation" @on-click="tabChange">
        <TabPane label="台风" name="taifeng">
          <div style="text-align:center">
            <div id="typhoon_div">
              <div id="con_div">
                年份：<select id="year_select" style="margin:4px;background: rgba(47,68,95, 0.9);color: #FFFFFF;"
                  ><option value="2016">2016</option></select
                >
                <!--<span style="margin-left:5px">输入名称：</span><input type="text" id="tfName" style="width:120px;height:24px">
                            <button id="search_typhoon" style="margin-left:10px;cursor:pointer">查询</button>-->
                <input type="hidden" style="margin-left:14px" />
                <!--自动刷新-->
              </div>
              <div
                id="typhoon_table_div"
                style="height:304px;overflow-y: overlay;"
              >
                <table id="typhoon_table_head" style="">
                  <thead>
                    <tr>
                      <th>选择</th>
                      <th>台风编号</th>
                      <th>台风名</th>
                      <th>英文名</th>
                    </tr>
                  </thead>
                </table>
                <div
                  id="typhoon_table_body_div"
                  style="height:270px;width:100%"
                >
                  <div id="typhoon_data_div">
                    <div id="progressflash" class="loadflash hiden">
                      <div class="loadingFlash">
                        <span
                          class="icon-loading"
                          style="font-size:24px;"
                        ></span>
                      </div>
                    </div>
                    <table
                      id="typhoon_table_body"
                      style="margin-top:0;border:1px solid gray"
                    >
                      <tbody></tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div id="typhoon_track_div" style="height:260px;">
                <div><span id="typhoonText" style="height:30px"></span></div>
                <table id="typhoon_track_table_head" style="">
                  <thead>
                    <tr style="border-bottom:1px solid gray">
                      <th>时间</th>
                      <th>风速（米/秒）</th>
                      <th style="width:70px">等级</th>
                      <th>移动方向</th>
                    </tr>
                  </thead>
                </table>
                <div
                  id="typhoon_track_table_div"
                  style="height:240px;overflow-y: overlay;"
                >
                  <div id="typhoon_track_data">
                    <table
                      id="typhoon_track_table_body"
                      style="margin-top:0;border:1px solid gray"
                    >
                      <tbody></tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </TabPane>
        <TabPane label="低压" name="diya">
          <div id="typhoon_track_div2" style="height:590px;text-align:center">
            <div><span id="typhoonText2" style="height:30px">历史低压选择</span></div>
            <table id="typhoon_table_head2" style="">
              <thead>
                <tr style="border-bottom:1px solid gray">
                  <th>选择</th>
                  <th>年份</th>
                  <th>ID</th>
                </tr>
              </thead>
            </table>
            <div
              id="typhoon_track_table_div2"
              style="height:304px;overflow-y: overlay;"
            >
              <div id="typhoon_track_data2">
                <table
                  id="typhoon_track_table_body2"
                  style="margin-top:0;border:1px solid gray"
                >
                  <tbody></tbody>
                </table>
              </div>
            </div>
            <div id="typhoon_track_div2" style="height:260px;">
                <div><span id="typhoonText2" style="height:30px">低压详细信息</span></div>
                <table id="typhoon_track_table_head2" style="">
                  <thead>
                    <tr style="border-bottom:1px solid gray">
                      <th>时间</th>
                      <th>风速（米/秒）</th>
                      <th style="width:70px">等级</th>
                      <th>移动方向</th>
                    </tr>
                  </thead>
                </table>
                <div
                  id="typhoon_track_table_div"
                  style="height:240px;overflow-y: overlay;"
                >
                  <div id="typhoon_track_data3">
                    <table
                      id="typhoon_track_table_body"
                      style="margin-top:0;border:1px solid gray"
                    >
                      <tbody></tbody>
                    </table>
                  </div>
                </div>
              </div>
          </div>
        </TabPane>
        <TabPane label="产品制作" name="chanpin">
          <div style="text-align: center">
            <div
              style="width: 320px;text-align: left;margin-bottom: 10px;margin-left: 86px;"
            >
              <p slot="title">
                添加弹窗：
              </p>
              <Button
                :type="idNum === 1 ? 'primary' : 'default'"
                @click="change(1)"
                >左侧</Button
              >
              <Button
                :type="idNum === 0 ? 'primary' : 'default'"
                @click="change(0)"
                >右侧</Button
              >
              <Button
                :type="idNum === 3 ? 'primary' : 'default'"
                @click="change(3)"
                >上边</Button
              >
              <Button
                :type="idNum === 2 ? 'primary' : 'default'"
                @click="change(2)"
                >下边</Button
              >
              <!-- <Button type="primary" @click="showToolTip($event, 'revoke')"
                >撤销</Button
              > -->
            </div>
            <div
              style="width: 320px;text-align: left;margin-bottom: 10px;margin-left: 86px;"
            >
              <Button
                :type="idNum === 4 ? 'primary' : 'default'"
                @click="change(4)"
                >左上</Button
              >
              <Button
                :type="idNum === 5 ? 'primary' : 'default'"
                @click="change(5)"
                >左下</Button
              >
              <Button
                :type="idNum === 6 ? 'primary' : 'default'"
                @click="change(6)"
                >右下</Button
              >
              <Button
                :type="idNum === 7 ? 'primary' : 'default'"
                @click="change(7)"
                >右上</Button
              >
            </div>
            <div
              style="width: 320px;text-align: left;margin-bottom: 10px;margin-left: 86px;"
            >
              <Button
                :type="'primary'"
                @click="startDraw"
                >测距</Button
              >
              <Button
                :type="'primary'"
                @click="clearDraw"
                >清除</Button
              >
            </div>
            <Button type="primary" @click="exportImg">导出产品</Button>
            <div style="margin-top: 10px">
                台风选择：<br>
                <Select v-model="selectYear" style="width:100px" @on-change="getChanpinTFBH(selectYear)">
                    <Option v-for="item in yearList" :value="item" :key="item">{{ item }}</Option>
                </Select>
                <Table border ref="selection" height="400" :columns="chanpinColumns" :data="chanpinData"></Table>
            </div>
          </div>
        </TabPane>
      </Tabs>

      <div slot="footer" style="padding: 0"></div>
    </Modal>
    <div class="product" v-if="productMapModal">
      <div id="Legend2">
        <table
          class="leaflet-control-legend leaflet-control"
          style="width: 235px;background: rgba(47,68,95, 0.9);"
        >
          <tbody class="">
            <tr class="">
              <td class="leaflet-control-legend-top-left"></td>
              <td class="leaflet-control-legend-top-center" align="right">
                <div class="leaflet-control-legend-title" align="left">
                  预报机构
                </div>
                <div class="leaflet-control-legend-title-down"></div>
              </td>
              <td class="leaflet-control-legend-top-right"></td>
            </tr>
            <tr class="">
              <td class="leaflet-control-legend-mid-left"></td>
              <td
                class="leaflet-control-legend-mid-center"
                style="display: block;"
              >
                <table class="typhoon-legend-main">
                  <tbody>
                    <tr>
                      <td>
                        <div style="float:left">
                          <input
                            type="checkbox"
                            class="typhoon-legend-input"
                            name="typhoon-legend"
                            value="中国"
                            id="China"
                            checked=""
                            @click="showTyphoonMap"
                          />
                          <div class="typhoon-legend-name">中国</div>
                        </div>
                      </td>
                      <td>
                        <div
                          class="typhoon-legend-command"
                          style="color:#FF6450"
                        >
                          ━ ━
                        </div>
                      </td>
                      <td>
                        <div style="float:left">
                          <input
                            type="checkbox"
                            class="typhoon-legend-input"
                            name="typhoon-legend"
                            value="中国香港"
                            id="HongKong"
                            checked=""
                            @click="showTyphoonMap"
                          />
                          <div class="typhoon-legend-name">中国香港</div>
                        </div>
                      </td>
                      <td>
                        <div
                          class="typhoon-legend-command"
                          style="color:#FF66FF"
                        >
                          ━ ━
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div style="float:left">
                          <input
                            type="checkbox"
                            class="typhoon-legend-input"
                            name="typhoon-legend"
                            value="日本"
                            id="Japan"
                            checked=""
                            @click="showTyphoonMap"
                          />
                          <div class="typhoon-legend-name">日本</div>
                        </div>
                      </td>
                      <td>
                        <div
                          class="typhoon-legend-command"
                          style="color:#43FF4B"
                        >
                          ━ ━
                        </div>
                      </td>
                      <td>
                        <div style="float:left">
                          <input
                            type="checkbox"
                            class="typhoon-legend-input"
                            name="typhoon-legend"
                            value="中国台湾"
                            id="Taiwan"
                            checked=""
                            @click="showTyphoonMap"
                          />
                          <div class="typhoon-legend-name">中国台湾</div>
                        </div>
                      </td>
                      <td>
                        <div
                          class="typhoon-legend-command"
                          style="color:#FFA040"
                        >
                          ━ ━
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div style="float:left">
                          <input
                            type="checkbox"
                            class="typhoon-legend-input"
                            name="typhoon-legend"
                            value="美国"
                            id="USA"
                            checked=""
                            @click="showTyphoonMap"
                          />
                          <div class="typhoon-legend-name">美国</div>
                        </div>
                      </td>
                      <td>
                        <div
                          class="typhoon-legend-command"
                          style="color:#40DDFF"
                        >
                          ━ ━
                        </div>
                      </td>
                      <td>
                        <div style="float:left">
                          <input
                            type="checkbox"
                            class="typhoon-legend-input"
                            name="typhoon-legend"
                            value="韩国"
                            id="korea"
                            checked=""
                            @click="showTyphoonMap"
                          />
                          <div class="typhoon-legend-name">韩国</div>
                        </div>
                      </td>
                      <td>
                        <div
                          class="typhoon-legend-command"
                          style="color:#669999"
                        >
                          ━ ━
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div style="float:left">
                          <input
                            type="checkbox"
                            class="typhoon-legend-input"
                            name="typhoon-legend"
                            value="欧洲"
                            id="Europe"
                            checked=""
                            @click="showTyphoonMap"
                          />
                          <div class="typhoon-legend-name">欧洲</div>
                        </div>
                      </td>
                      <td>
                        <div
                          class="typhoon-legend-command"
                          style="color:#373591"
                        >
                          ━ ━
                        </div>
                      </td>
                      <td>
                        <div style="float:left">
                          <input
                            type="checkbox"
                            class="typhoon-legend-input"
                            name="typhoon-legend"
                            value="中大预报"
                            id="zhongda"
                            checked=""
                            @click="showTyphoonMap"
                          />
                          <div class="typhoon-legend-name">中大预报</div>
                        </div>
                      </td>
                      <td>
                        <div
                          class="typhoon-legend-command"
                          style="color:#FF0000"
                        >
                          ━ ━
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td
                class="leaflet-control-legend-mid-center-hid"
                style="display: none;"
              ></td>
              <td class="leaflet-control-legend-mid-right"></td>
            </tr>
            <tr class="">
              <td class="leaflet-control-legend-foot-left"></td>
              <td class="leaflet-control-legend-foot-center"></td>
              <td class="leaflet-control-legend-foot-right"></td>
            </tr>
          </tbody>
        </table>
        <table
          class="leaflet-control-legend leaflet-control"
          style="width: 235px;background: rgba(47,68,95, 0.9);"
        >
          <tbody class="">
            <tr class="">
              <td class="leaflet-control-legend-top-left"></td>
              <td class="leaflet-control-legend-top-center" align="right">
                <div class="leaflet-control-legend-title" align="left">
                  台风图例
                </div>
                <div class="leaflet-control-legend-title-down"></div>
              </td>
              <td class="leaflet-control-legend-top-right"></td>
            </tr>
            <tr class="">
              <td class="leaflet-control-legend-mid-left"></td>
              <td
                class="leaflet-control-legend-mid-center"
                style="display: block;"
              >
                <div class="typhoon-maplegend-main">
                  <div class="typhoon-maplegend-child">
                    <svg width="100%" height="100%">
                      <circle
                        xmlns="http://www.w3.org/2000/svg"
                        cx="6"
                        cy="6"
                        r="5"
                        stroke="black"
                        stroke-width="1"
                        stroke-opacity="0.8"
                        fill-opacity="1"
                        fill="#008D00"
                      ></circle>
                    </svg>
                  </div>
                  <div class="typhoon-maplegend-text">
                    热带低压
                  </div>
                  <div class="typhoon-maplegend-child">
                    <svg width="100%" height="100%">
                      <circle
                        xmlns="http://www.w3.org/2000/svg"
                        cx="6"
                        cy="6"
                        r="5"
                        stroke="black"
                        stroke-width="1"
                        stroke-opacity="0.8"
                        fill-opacity="1"
                        fill="#4097EF"
                      ></circle>
                    </svg>
                  </div>
                  <div class="typhoon-maplegend-text">
                    热带风暴
                  </div>
                  <div style="clear:both"></div>
                  <div class="typhoon-maplegend-child">
                    <svg width="100%" height="100%">
                      <circle
                        xmlns="http://www.w3.org/2000/svg"
                        cx="6"
                        cy="6"
                        r="5"
                        stroke="black"
                        stroke-width="1"
                        stroke-opacity="0.8"
                        fill-opacity="1"
                        fill="#FFFF00"
                      ></circle>
                    </svg>
                  </div>
                  <div class="typhoon-maplegend-text">
                    强热带风暴
                  </div>
                  <div class="typhoon-maplegend-child">
                    <svg width="100%" height="100%">
                      <circle
                        xmlns="http://www.w3.org/2000/svg"
                        cx="6"
                        cy="6"
                        r="5"
                        stroke="black"
                        stroke-width="1"
                        stroke-opacity="0.8"
                        fill-opacity="1"
                        fill="#FF7500"
                      ></circle>
                    </svg>
                  </div>
                  <div class="typhoon-maplegend-text">
                    台风
                  </div>
                  <div style="clear:both"></div>
                  <div class="typhoon-maplegend-child">
                    <svg width="100%" height="100%">
                      <circle
                        xmlns="http://www.w3.org/2000/svg"
                        cx="6"
                        cy="6"
                        r="5"
                        stroke="black"
                        stroke-width="1"
                        stroke-opacity="0.8"
                        fill-opacity="1"
                        fill="#FF00FF"
                      ></circle>
                    </svg>
                  </div>
                  <div class="typhoon-maplegend-text">
                    强台风
                  </div>
                  <div class="typhoon-maplegend-child">
                    <svg width="100%" height="100%">
                      <circle
                        xmlns="http://www.w3.org/2000/svg"
                        cx="6"
                        cy="6"
                        r="5"
                        stroke="black"
                        stroke-width="1"
                        stroke-opacity="0.8"
                        fill-opacity="1"
                        fill="#DB0000"
                      ></circle>
                    </svg>
                  </div>
                  <div class="typhoon-maplegend-text">
                    超强台风
                  </div>
                  <div style="clear:both"></div>
                </div>
              </td>
              <td
                class="leaflet-control-legend-mid-center-hid"
                style="display: none;"
              ></td>
              <td class="leaflet-control-legend-mid-right"></td>
            </tr>
            <tr class="">
              <td class="leaflet-control-legend-foot-left"></td>
              <td class="leaflet-control-legend-foot-center"></td>
              <td class="leaflet-control-legend-foot-right"></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="top">
        <Input v-model="prTitle" type="text" placeholder="Enter something..." class="bubble_tooltip_textarea2"/>
      </div>
      <div class="mid">
        <Weathermap v-on:getMap="getMap2" id="productMap"></Weathermap>
      </div>
      <div class="btm">
        <Input
          class="bubble_tooltip_textarea2"
          v-model="prContent"
          type="textarea"
          :rows="2"
          placeholder="Enter something..."
        />
      </div>
    </div>
    <!-- <Weathermap v-on:getMap="getMap" id="huananMap"></Weathermap> -->
  </div>
</template>
<script>
import html2canvas from "html2canvas";
import Weathermap from "@/map/weathermap.vue";
import typhoonImg from "../../assets/img/typhoon.gif";
import typhoonImg2 from "../../assets/img/typhoon.png";
import "../../assets/css/huananForecast.css";
import $ from "jquery";
import moment from "moment";

export default {
  components: {
    Weathermap
  },
  data() {
    return {
      modal2: false,
      typhoonPointLayer: null, //台风实况点图层
      typhoonLineLayer: null, //台风实况线图层
      typhoonYubaoPointLayer: null, //台风预报点图层
      typhoonYubaoLineLayer: null, //台风预报线图层
      typhoonFengquanLayer: null, //风圈图层
      typhoonContainer: null, //台风图层容器
      typhoonVectorList: {}, //台风实况点列表
      map: null,
      ybList: [], //预报路径
      operation: "taifeng",
      productMapModal: false,
      map2: null,
      typhoonPointLayer2: null, //台风实况点图层
      typhoonLineLayer2: null, //台风实况线图层
      typhoonYubaoPointLayer2: null, //台风预报点图层
      typhoonYubaoLineLayer2: null, //台风预报线图层
      typhoonFengquanLayer2: null, //风圈图层
      typhoonContainer2: null, //台风图层容器
      kekaoLine: [], //科考航线数据
      kekaoPointLayer2: null, //科考航线点图层
      kekaoLineLayer2: null, //科考航线线图层
      hangxian: false,
      prTitle: "  中山大学台风科研平台",
      prContent:
        "【TY28 “鹦鹉” 5日08时报】： 台风 “鹦鹉” 目前位于南海距离三亚648公里，预计以12公里/小时南方向移动",
      idNum: 0,
      recordList: [],
      recordLonLat: [],
      recordidNum: [],
      currentId: null,
      clickPoint: null,
      lastForData: null,
      allPointList: [],
      yearList: [],
      selectYear: '',
      currentChoose: '',
      chanpinColumns: [
        {
            title: '选择',
            key: 'tfid',
            width: 80,
            align: 'center',
            render: (h, params) => {
              let id = params.row.tfid;
              let flag = false;
              if (this.currentChoose === id) {
                flag = true
              } else {
                flag = false
              }
              let self = this
              return h('div', [
                h('Radio', {
                  props: {
                    value: flag
                  },
                  on: {
                    'on-change': () => {
                      self.currentChoose = id;
                    }
                  }
                })
              ])
            }

        },
        {
            title: '台风编号',
            key: 'tfid',
            width: 100
        },
        {
            title: '台风名',
            key: 'name',
            width: 100
        },
        {
            title: '英文名',
            key: 'enname',
            width: 117
        }
      ],
      chanpinData: [],
      drawStyle: {
        strokeColor:"#ff0000",
        fillColor:"#ff0000",
        fillOpacity:0.6
      },
      dxlineLayer: null,
      dxdrawLine: null,
      dxdrawLayer: null,
      dxdrawLineList: [],
      hangxianList: [],
      hangxianSelect: 5
    };
  },
  mounted() {
    let me = this;
    this.$nextTick(function() {
      me.modal2 = true;
      $.post(
        this.$ipConfig.getHisTyphoonData + "&starttime=" + moment().year()
      ).then(data2 => {
        let lateTyphoon = data2.dataList[0];
        me.prContent = `【TY${lateTyphoon.tfid.toString().substring(4, 6)} “${
          lateTyphoon.name
        }” ${Number(moment().format("DD"))}日08时报】： 台风 “${
          lateTyphoon.name
        }” 目前位于南海距离三亚648公里，预计以12公里/小时南方向移动`;
        me.currentId = data2.dataList[0].tfid;
      });

      $.get(this.$ipConfig.getFishLineInfo + "&thisid=1").then(data => {
        if (data.message === "查询成功") {
          me.kekaoLine = data.dataList;
        } else {
          me.$Message.error({
            content: data.message,
            duration: 5
          });
        }
      });
    });
    $.post(me.$ipConfig.getTyhphoonAllLine).then(data => {
      me.hangxianList = data.dataList;
      me.hangxianSelect = data.dataList[0].id;
    })

    $.post(me.$ipConfig.host + 'getHisLowTrack').then(data => {
      let t = this;
      let lowPresData = data.dataList.reverse();
      let html = "";
      lowPresData.map(item => {
         html +=
            '<tr><td><input type="radio" id="' +
            item.tyear + '_' + item.trackid +
            '" style="cursor: pointer;" name="checkboxTFBH" year="' +
            item.tyear + '"' +
            "></td>" +
            "<td>" +
            item.tyear +
            "</td>" +
            "<td>" +
            item.trackid +
            "</td>" +
            "</tr>";
      })
      $("#typhoon_track_table_body2 tbody").html(html);
      $("#typhoon_track_table_body2 input:radio").click(function() {
        t.ischeck2(this);
      });
    })
    this.map = this.$store.state.map;
  },
  watch: {
    map(a, b) {
      // this.map.zoomToScale(1 / 12000000, true);
      this.initMap();
    },
    map2(a, b) {
      this.initMap2();
    },
    currentChoose(){
        this.recordList = [];
        this.recordLonLat = [];
        this.recordidNum = [];
        $('.bubble_tooltip_common').remove();
        this.showTyphoonMap();
    }
  },
  methods: {
    hangxianChange(e) {
      this.kekaoPointLayer2.setVisibility(e);
      this.kekaoLineLayer2.setVisibility(e);
    },
    tabChange(e) {
      this.productMapModal = false;
      if (e == "taifeng") {
        this.operation = e;
        this.allPointList = [];
        this.init_time_select();
        this.getTFBH(
          $("#year_select option:selected").val(),
          $("#tfName").val()
        );
      } else if (e == "diya") {
        this.operation = e;
        this.clearTyphoonGra();
        $("#typhoon_track_data2").find('tr').eq(0).find('input').click();
      } else {
        this.operation = e;
        this.getChanpinTFBH(moment().year());
        this.productMapModal = true;
      }
    },
    ok() {},
    /**ajax请求数据  根据年份请求台风列表
     *@params year 年份
     **/
    getChanpinTFBH: function(year) {
      let t = this;
      //清除轨迹信息
      $.post(this.$ipConfig.getHisTyphoonData + "&starttime=" + year).then(
        data2 => {
          if (data2.message === "查询成功") {
            t.chanpinData = data2.dataList;
            t.currentChoose = data2.dataList[0].tfid;
          } else {
            t.$Message.error({
              content: data.message,
              duration: 5
            });
          }
        }
      );
    },
    changeHangxian(val) {
      let t = this;
      $.get(this.$ipConfig.getFishLineInfo + "&thisid=" + val).then(data => {
        if (data.message === "查询成功") {
          t.kekaoLine = data.dataList;
          let trackData = t.kekaoLine;
          var pointList = [];

          var lineFeatures = [];
          var pointAnimatorList = [];
          var lineVector;
          for (var i = 0; i < trackData.length; i++) {
            var arr = [];
            var point = new WeatherMap.Geometry.Point(
              trackData[i].lon,
              trackData[i].lat
            );
            pointList.push(point);
            var attribute = trackData[i];
            attribute.type = "科考航线点";
            attribute.typhoonNum = i;
            var pointAnimator;
            switch (attribute.stanum) {
              case "zhzw":
                pointAnimator = new WeatherMap.Feature.Vector(point, attribute, {
                  externalGraphic: "https://www.moodsmap.com/img/zhzw.png",
                  pointRadius: 10,
                  graphicOpacity: 0.9
                });
                break;
              case "dz":
                pointAnimator = new WeatherMap.Feature.Vector(point, attribute, {
                  externalGraphic: "https://www.moodsmap.com/img/dz.png",
                  pointRadius: 10,
                  graphicOpacity: 0.9
                });
                break;
              case "qbz":
                pointAnimator = new WeatherMap.Feature.Vector(point, attribute, {
                  externalGraphic: "https://www.moodsmap.com/img/qbz.png",
                  pointRadius: 10,
                  graphicOpacity: 0.9
                });
                break;
              case "lxgcz":
                pointAnimator = new WeatherMap.Feature.Vector(point, attribute, {
                  externalGraphic: "https://www.moodsmap.com/img/lxgcz.png",
                  pointRadius: 10,
                  graphicOpacity: 0.9
                });
                break;
              case "sh":
                pointAnimator = new WeatherMap.Feature.Vector(point, attribute, {
                  externalGraphic: "https://www.moodsmap.com/img/sh.png",
                  pointRadius: 10,
                  graphicOpacity: 0.9
                });
                break;
            }

            pointAnimatorList.push(pointAnimator);
            var line = new WeatherMap.Geometry.LineString(pointList);
            arr.push(line);
            var multiLineString = new WeatherMap.Geometry.MultiLineString(arr);
            lineVector = new WeatherMap.Feature.Vector(multiLineString, {
              FEATUREID: 1,
              TIME: i
            });
            lineVector.id = attribute.id;
            lineVector.style = {
              strokeColor: "rgb(51,204,51)",
              strokeWidth: 3
            };
            lineFeatures.push(lineVector);
          }
          t.kekaoPointLayer2.removeAllFeatures();
          t.kekaoLineLayer2.removeAllFeatures();
          t.kekaoPointLayer2.addFeatures(pointAnimatorList);
          t.kekaoLineLayer2.addFeatures(lineFeatures);
        } else {
          t.$Message.error({
            content: data.message,
            duration: 5
          });
        }
      });
    },
    //获取白板图组件的地图对象
    getMap(data) {
      this.map = data;
    },
    getMap2(data) {
      this.map2 = data;
    },
    //初始化地图图层
    initMap2() {
      let t = this;
      t.typhoonPointLayer2 = new WeatherMap.Layer.Vector("point");
      t.typhoonLineLayer2 = new WeatherMap.Layer.Vector("Line");
      t.typhoonYubaoPointLayer2 = new WeatherMap.Layer.Vector("yubaoPoint");
      t.typhoonYubaoLineLayer2 = new WeatherMap.Layer.Vector("yubaoLine");
      t.typhoonFengquanLayer2 = new WeatherMap.Layer.Vector("fengquan2");
      //画线
      t.dxdrawLayer = new WeatherMap.Layer.Vector("drawLayer");
      t.dxlineLayer = new WeatherMap.Layer.Vector("dxlineLayer");
      let control = new WeatherMap.Control();
      let msg = null
      WeatherMap.Util.extend(control, {
        draw: function () {
          t.dxdrawLine = new WeatherMap.Handler.Path(control,
            {"create":this.start, "point": this.notice, "done": this.drawCompleted}
          )
        },
        start: function() {
          t.dxdrawLineList = [];
        },
        notice: function (event) {
          var point = new WeatherMap.Geometry.Point(event.x, event.y);
          t.dxdrawLineList.push(point);
          if(t.dxdrawLineList.length == 1){
            t.dxlineLayer.removeAllFeatures();
            t.dxdrawLayer.removeAllFeatures();
            var pointVector = new WeatherMap.Feature.Vector(point, {});
            pointVector.style = {
              label: '起点',
              fillColor: 'red',
              labelYOffset: 15,
              strokeWidth: 0.5,
              pointRadius: 5
            };
            t.dxdrawLayer.addFeatures([pointVector]);
          }else{
            var line = new WeatherMap.Geometry.LineString(t.dxdrawLineList);
            var lineVector = new WeatherMap.Feature.Vector(line, {
                FEATUREID: 1,
                TIME: 1
              });
              lineVector.style = {
                strokeColor: "rgb(0,118,201)",
                strokeWidth: 2
              };
            var distance = t.getDistance(lineVector.geometry);
            var pointVector = new WeatherMap.Feature.Vector(point, {});
            pointVector.style = {
              label: distance,
              labelYOffset: 15,
              fillColor: 'red',
              strokeWidth: 0.5,
              pointRadius: 5
            };
            t.dxdrawLayer.addFeatures([pointVector]);
            t.dxlineLayer.removeAllFeatures();
            t.dxlineLayer.addFeatures([lineVector]);
          }

        },
        drawCompleted(event) {

        },
      })
      t.map2.addControl(control)

      // t.dxdrawLine = new WeatherMap.Control.DrawFeature(t.dxdrawLayer, WeatherMap.Handler.Path,{ multi: true});
      // t.map2.addControl(t.dxdrawLine);
      // t.dxdrawLine.events.on({"featureadded": t.drawCompleted});

      t.typhoonContainer2 = new WeatherMap.Layer.Vector.RootContainer(
        "t.typhoonContainer2"
      );
      t.typhoonContainer2.layers = [
        t.typhoonYubaoPointLayer2,
        t.typhoonPointLayer2
      ];
      t.map2.addLayers([
        t.typhoonFengquanLayer2,
        t.dxdrawLayer,
        t.dxlineLayer,
        t.typhoonYubaoLineLayer2,
        t.typhoonLineLayer2,
        t.typhoonYubaoPointLayer2,
        t.typhoonPointLayer2,
        t.typhoonContainer2
      ]);
      t.map2.setLayerIndex(t.typhoonFengquanLayer2, 0);

      let selectFeature2 = new WeatherMap.Control.SelectFeature(
        t.typhoonContainer2,
        {
          callbacks: {
            click: function(currentFeature) {
              t.showToolTip(currentFeature);
            }
          }
        }
      );
      selectFeature2.id = "typhoonSelectFeature2";
      t.map2.addControl(selectFeature2);
      selectFeature2.activate();
      t.currentChoose = moment().format('YYYY');
      t.showTyphoonMap();
    },
    //产品制作
    showTyphoonMap() {
      let t = this;
      t.typhoonPointLayer2.removeAllFeatures();
      t.typhoonPointLayer2.removeAllFeatures();
      t.typhoonLineLayer2.removeAllFeatures();
      t.typhoonYubaoLineLayer2.removeAllFeatures();
      t.typhoonYubaoPointLayer2.removeAllFeatures();
      t.typhoonFengquanLayer2.removeAllFeatures();
    //   $.post(this.$ipConfig.getHisTyphoonData + "&starttime=" + t.currentChoose).then(element => {
        let tfbh = t.currentChoose;
        $.get(this.$ipConfig.getTyphoonPathData + "&element=" + t.currentChoose).then(
          data => {
            let lateTyphoon = data.dataList[0];
            t.prContent = `【TY${lateTyphoon.tfid.toString().substring(4, 6)} “${
              lateTyphoon.name
            }” ${Number(moment().format("DD"))}日08时报】： 台风 “${
              lateTyphoon.name
            }” 目前位于南海距离三亚648公里，预计以12公里/小时南方向移动`;
            t.currentId = data.dataList[0].tfid;
            let trackData = data.dataList;
            var pointList = [];
            var fengPoint = new WeatherMap.Geometry.Point(
              trackData[trackData.length - 1].lng,
              trackData[trackData.length - 1].lat
            );
            var attribute = trackData[trackData.length - 1];
            attribute.type = "台风路径点";
            attribute.typhoonNum = trackData.length - 1;
            var typhoonlevel = t.getTyphoonInformation(attribute.speed);
            attribute.level = typhoonlevel.name;
            var fengPointVector = new WeatherMap.Feature.Vector(
              fengPoint,
              attribute,
              {
                externalGraphic: typhoonImg2,
                pointRadius: 30,
                graphicOpacity: 0.9
              }
            );
            fengPointVector.id = tfbh + "feng";
            var lineFeatures = [];
            var pointAnimatorList = [];
            var lineVector;
            for (var i = 0; i < trackData.length; i++) {
              var arr = [];
              var point = new WeatherMap.Geometry.Point(
                trackData[i].lng,
                trackData[i].lat
              );
              pointList.push(point);
              var attribute = trackData[i];
              attribute.type = "台风路径点";
              attribute.typhoonNum = i;
              var typhoonlevel = t.getTyphoonInformation(attribute.speed);
              attribute.level = typhoonlevel.name;
              var pointVector = new WeatherMap.Feature.Vector(point, attribute);
              pointVector.id = tfbh + trackData[i].time;
              pointVector.style = {
                fillColor: typhoonlevel.color,
                strokeWidth: 0.5,
                pointRadius: 5
              };
              var pointAnimator = new WeatherMap.Feature.Vector(
                point,
                attribute
              );
              pointAnimator.style = {
                fillColor: typhoonlevel.color,
                strokeWidth: 0.5,
                pointRadius: 5
              };
              pointAnimatorList.push(pointAnimator);
              //   typhoonPointList.push(pointVector);
              // t.typhoonPointLayer.addFeatures([pointVector]);
              var line = new WeatherMap.Geometry.LineString(pointList);
              arr.push(line);
              var multiLineString = new WeatherMap.Geometry.MultiLineString(
                arr
              );
              lineVector = new WeatherMap.Feature.Vector(multiLineString, {
                FEATUREID: 1,
                TIME: i
              });
              lineVector.id = tfbh;
              lineVector.style = {
                strokeColor: "rgb(0,118,201)",
                strokeWidth: 2
              };
              lineFeatures.push(lineVector);
            }
            var locationPoint = new WeatherMap.LonLat(
              trackData[trackData.length - 1].lng,
              trackData[trackData.length - 1].lat
            );
            t.typhoonPointLayer2.addFeatures(pointAnimatorList);
            t.typhoonPointLayer2.addFeatures([fengPointVector]);
            t.typhoonLineLayer2.addFeatures(lineFeatures);
            t.map2.panTo(locationPoint);
            t.map2.zoomTo(6);

            var yubaoPoint = trackData[trackData.length - 1];
            //风圈
            //圆
            if (yubaoPoint.en7radii != null) {
              var centerPoint = new WeatherMap.Geometry.Point(
                yubaoPoint.lng,
                yubaoPoint.lat
              );
              var radius = yubaoPoint.en7radii / 110;
              var circleP = t.createCircle(centerPoint, radius, 64, 270, 90);
              var circleVector = new WeatherMap.Feature.Vector(circleP);
              circleVector.style = {
                strokeColor: "rgb(224,172,82)",
                fillColor: "rgb(224,172,82)",
                // strokeWidth: 1,
                fillOpacity: 0.4,
                stroke: false
              };
              t.typhoonFengquanLayer2.addFeatures([circleVector]);
            }
            if (yubaoPoint.es7radii != null) {
              var centerPoint = new WeatherMap.Geometry.Point(
                yubaoPoint.lng,
                yubaoPoint.lat
              );
              var radius = yubaoPoint.es7radii / 110;
              var circleP = t.createCircle(centerPoint, radius, 64, 180, 90);
              var circleVector = new WeatherMap.Feature.Vector(circleP);
              circleVector.style = {
                strokeColor: "rgb(224,172,82)",
                fillColor: "rgb(224,172,82)",
                strokeWidth: 1,
                fillOpacity: 0.4,
                stroke: false
              };
              t.typhoonFengquanLayer2.addFeatures([circleVector]);
            }
            if (yubaoPoint.ws7radii != null) {
              var centerPoint = new WeatherMap.Geometry.Point(
                yubaoPoint.lng,
                yubaoPoint.lat
              );
              var radius = yubaoPoint.ws7radii / 110;
              var circleP = t.createCircle(centerPoint, radius, 64, 90, 90);
              var circleVector = new WeatherMap.Feature.Vector(circleP);
              circleVector.style = {
                strokeColor: "rgb(224,172,82)",
                fillColor: "rgb(224,172,82)",
                strokeWidth: 1,
                fillOpacity: 0.4,
                stroke: false
              };
              t.typhoonFengquanLayer2.addFeatures([circleVector]);
            }
            if (yubaoPoint.wn7radii != null) {
              var centerPoint = new WeatherMap.Geometry.Point(
                yubaoPoint.lng,
                yubaoPoint.lat
              );
              var radius = yubaoPoint.wn7radii / 110;
              var circleP = t.createCircle(centerPoint, radius, 64, 0, 90);
              var circleVector = new WeatherMap.Feature.Vector(circleP);
              circleVector.style = {
                strokeColor: "rgb(224,172,82)",
                fillColor: "rgb(224,172,82)",
                strokeWidth: 1,
                fillOpacity: 0.4,
                stroke: false
              };
              t.typhoonFengquanLayer2.addFeatures([circleVector]);
            }
            //圆
            if (yubaoPoint.en10radii != null) {
              var centerPoint = new WeatherMap.Geometry.Point(
                yubaoPoint.lng,
                yubaoPoint.lat
              );
              var radius = yubaoPoint.en10radii / 110;
              var circleP = t.createCircle(centerPoint, radius, 64, 270, 90);
              var circleVector = new WeatherMap.Feature.Vector(circleP);
              circleVector.style = {
                strokeColor: "rgb(224,172,82)",
                fillColor: "rgb(224,172,82)",
                // strokeWidth: 1,
                fillOpacity: 0.4,
                stroke: false
              };
              t.typhoonFengquanLayer2.addFeatures([circleVector]);
            }
            if (yubaoPoint.es10radii != null) {
              var centerPoint = new WeatherMap.Geometry.Point(
                yubaoPoint.lng,
                yubaoPoint.lat
              );
              var radius = yubaoPoint.es10radii / 110;
              var circleP = t.createCircle(centerPoint, radius, 64, 180, 90);
              var circleVector = new WeatherMap.Feature.Vector(circleP);
              circleVector.style = {
                strokeColor: "rgb(224,172,82)",
                fillColor: "rgb(224,172,82)",
                strokeWidth: 1,
                fillOpacity: 0.4,
                stroke: false
              };
              t.typhoonFengquanLayer2.addFeatures([circleVector]);
            }
            if (yubaoPoint.ws10radii != null) {
              var centerPoint = new WeatherMap.Geometry.Point(
                yubaoPoint.lng,
                yubaoPoint.lat
              );
              var radius = yubaoPoint.ws10radii / 110;
              var circleP = t.createCircle(centerPoint, radius, 64, 90, 90);
              var circleVector = new WeatherMap.Feature.Vector(circleP);
              circleVector.style = {
                strokeColor: "rgb(224,172,82)",
                fillColor: "rgb(224,172,82)",
                strokeWidth: 1,
                fillOpacity: 0.4,
                stroke: false
              };
              t.typhoonFengquanLayer2.addFeatures([circleVector]);
            }
            if (yubaoPoint.wn10radii != null) {
              var centerPoint = new WeatherMap.Geometry.Point(
                yubaoPoint.lng,
                yubaoPoint.lat
              );
              var radius = yubaoPoint.wn10radii / 110;
              var circleP = t.createCircle(centerPoint, radius, 64, 0, 90);
              var circleVector = new WeatherMap.Feature.Vector(circleP);
              circleVector.style = {
                strokeColor: "rgb(224,172,82)",
                fillColor: "rgb(224,172,82)",
                strokeWidth: 1,
                fillOpacity: 0.4,
                stroke: false
              };
              t.typhoonFengquanLayer2.addFeatures([circleVector]);
            }

            let yubaoList = {};
            let yubao = trackData[trackData.length - 1];
             $.get(
                this.$ipConfig.getTyphoonForData + "&thisid=" + tfbh
                ).then(data => {
                    data.dataList.map(item => {
                        if (!yubaoList[item.forecastAddress]) {
                            yubaoList[item.forecastAddress] = [];
                            yubaoList[item.forecastAddress].push(yubao);
                        }
                        yubaoList[item.forecastAddress].push(item);
                    });
                    var point;
                    var curPoint;
                    Object.keys(yubaoList).map(e => {
                    let list = yubaoList[e];
                    if (!$('.product input[value="' + e + '"]').is(":checked"))
                        list = [];
                    var pointList = [];
                    for (var j = 0; j < list.length; j++) {
                        if (j == 0 && list[j].lng != 9999) {
                        trackData.map(item => {
                            if(item.currentId == list[1].currentId){
                                curPoint = item;
                                point = new WeatherMap.Geometry.Point(item.lng, item.lat);
                            }
                            })
                        //   point = new WeatherMap.Geometry.Point(yubao.lng, yubao.lat);
                        } else {
                          if (j == 0) {
                              point = new WeatherMap.Geometry.Point(yubao.lng, yubao.lat);
                              pointList.push(point);
                          }
                          point = new WeatherMap.Geometry.Point(
                              list[j].lng,
                              list[j].lat
                          );
                        }
                        if(curPoint.time > list[j].time && j != 0) continue;
                        pointList.push(point);
                        var attribute = list[j];
                        attribute.type = "台风预报点";
                        if(j == 0) {
                            attribute.type = "台风路径点";
                        }
                        var pointVector = new WeatherMap.Feature.Vector(
                        point,
                        attribute
                        );
                        var color = t.getTyphoonPointColor(attribute.speed);
                        pointVector.name = attribute.tfid;
                        pointVector.style = {
                        fillColor: color,
                        strokeWidth: 0.5,
                        pointRadius: 5
                        };
                        t.typhoonYubaoPointLayer2.addFeatures([pointVector]);
                    }
                    var line = new WeatherMap.Geometry.LineString(pointList);
                    var lineVector = new WeatherMap.Feature.Vector(line);
                    var lineColor = "red";
                    if (list.length != 0) {
                        lineColor = t.getTyphoonYubaoLine(list[1].forecastAddress);
                    }
                    lineVector.style = {
                        strokeColor: lineColor,
                        strokeDashstyle: "dash",
                        strokeWidth: 2
                    };
                    lineVector.name = yubao.tfid;
                    t.typhoonYubaoLineLayer2.addFeatures([lineVector]);
                    });
                })

          }
        );
    //   });
    },
    //初始化地图图层
    initMap() {
      let t = this;
      t.typhoonPointLayer = new WeatherMap.Layer.Vector("point");
      t.typhoonLineLayer = new WeatherMap.Layer.Vector("Line");

      t.typhoonYubaoPointLayer = new WeatherMap.Layer.Vector("yubaoPoint");
      t.typhoonYubaoLineLayer = new WeatherMap.Layer.Vector("yubaoLine");
      t.typhoonContainer = new WeatherMap.Layer.Vector.RootContainer(
        "t.typhoonContainer"
      );
      t.typhoonFengquanLayer = new WeatherMap.Layer.Vector("fengquan");
      t.typhoonContainer.layers = [
        t.typhoonYubaoPointLayer,
        t.typhoonPointLayer
      ];
      t.kekaoPointLayer2 = new WeatherMap.Layer.Vector("kekaopoint");
      t.kekaoLineLayer2 = new WeatherMap.Layer.Vector("kekaoLine");
      t.kekaoPointLayer2.setVisibility(false);
      t.kekaoLineLayer2.setVisibility(false);

      t.map.addLayers([
        t.typhoonFengquanLayer,
        t.kekaoLineLayer2,
        t.typhoonYubaoLineLayer,
        t.typhoonLineLayer,
        t.kekaoPointLayer2,
        t.typhoonYubaoPointLayer,
        t.typhoonPointLayer,
        t.typhoonContainer
      ]);
      t.map.setLayerIndex(t.typhoonFengquanLayer, 0);

      let selectFeature = new WeatherMap.Control.SelectFeature(
        t.typhoonContainer,
        {
          callbacks: {
            over: function(currentFeature) {
              t.addMyInfoWindow(currentFeature);
            },
            out: function(currentFeature) {
              t.map.removeAllPopup();
            },
            click: function(currentFeature) {
              let attributes = currentFeature.attributes;
              if(attributes.type == '台风路径点'){
                t.addForcastData(currentFeature.attributes);
              }
            }
          }
        }
      );
      selectFeature.id = "typhoonSelectFeature";
      t.map.addControl(selectFeature);
      selectFeature.activate();
      t.init_time_select();
      t.getTFBH($("#year_select option:selected").val(), $("#tfName").val());

      setTimeout(function() {
        let trackData = t.kekaoLine;
        var pointList = [];

        var lineFeatures = [];
        var pointAnimatorList = [];
        var lineVector;
        for (var i = 0; i < trackData.length; i++) {
          var arr = [];
          var point = new WeatherMap.Geometry.Point(
            trackData[i].lon,
            trackData[i].lat
          );
          pointList.push(point);
          var attribute = trackData[i];
          attribute.type = "科考航线点";
          attribute.typhoonNum = i;
          var pointAnimator;
          switch (attribute.stanum) {
            case "zhzw":
              pointAnimator = new WeatherMap.Feature.Vector(point, attribute, {
                externalGraphic: "https://www.moodsmap.com/img/zhzw.png",
                pointRadius: 10,
                graphicOpacity: 0.9
              });
              break;
            case "dz":
              pointAnimator = new WeatherMap.Feature.Vector(point, attribute, {
                externalGraphic: "https://www.moodsmap.com/img/dz.png",
                pointRadius: 10,
                graphicOpacity: 0.9
              });
              break;
            case "qbz":
              pointAnimator = new WeatherMap.Feature.Vector(point, attribute, {
                externalGraphic: "https://www.moodsmap.com/img/qbz.png",
                pointRadius: 10,
                graphicOpacity: 0.9
              });
              break;
            case "lxgcz":
              pointAnimator = new WeatherMap.Feature.Vector(point, attribute, {
                externalGraphic: "https://www.moodsmap.com/img/lxgcz.png",
                pointRadius: 10,
                graphicOpacity: 0.9
              });
              break;
            case "sh":
              pointAnimator = new WeatherMap.Feature.Vector(point, attribute, {
                externalGraphic: "https://www.moodsmap.com/img/sh.png",
                pointRadius: 10,
                graphicOpacity: 0.9
              });
              break;
          }

          pointAnimatorList.push(pointAnimator);
          var line = new WeatherMap.Geometry.LineString(pointList);
          arr.push(line);
          var multiLineString = new WeatherMap.Geometry.MultiLineString(arr);
          lineVector = new WeatherMap.Feature.Vector(multiLineString, {
            FEATUREID: 1,
            TIME: i
          });
          lineVector.id = attribute.id;
          lineVector.style = {
            strokeColor: "rgb(51,204,51)",
            strokeWidth: 3
          };
          lineFeatures.push(lineVector);
        }
        t.kekaoPointLayer2.addFeatures(pointAnimatorList);
        t.kekaoLineLayer2.addFeatures(lineFeatures);
      }, 1000);
    },
    /**初始化时间选择框**/
    init_time_select: function() {
      let t = this;
      var html = "";
      var time = new Date();
      var firstDate = 1949; //2010年以后所有台风
      var curr = time.getFullYear();
      var now = curr;
      t.selectYear = time.getFullYear();
      t.yearList = [];
      while (now >= firstDate) {
        html += '<option value="' + now + '">' + now + "</option>";
        t.yearList.push(now);
        now--;
      }
      $("#year_select").html(html);
      $("#year_select").bind("change", function() {
        var year = $(this)
          .children("option:selected")
          .text();
        var name = $("#tfName").val();
        t.getTFBH(year, name);
      });
      $("#search_typhoon").bind("click", function() {
        var year = $("#year_select option:selected").val();
        var name = $("#tfName").val();
        t.getTFBH(year, name);
      });
    },
    /**ajax请求数据  根据年份请求台风列表
     *@params year 年份
     **/
    getTFBH: function(year) {
      let t = this;
      this.allPointList = [];
      t.clearTyphoonGra();
      $("#typhoon_table_body tbody").html("");
      //清除轨迹信息
      $("#typhoon_track_table_body tbody").html("");
      $.post(this.$ipConfig.getHisTyphoonData + "&starttime=" + year).then(
        data2 => {
          if (data2.message === "查询成功") {
            let data = data2.dataList;
            let html = "";
            if (data.length > 0) {
              var firstTyphoonID = "";
              for (var i = 0; i < data.length; i++) {
                var tfdata = data[i];
                var checkString = "";
                if (i == 0) {
                  firstTyphoonID = tfdata.tfid;
                }
                html +=
                  '<tr><td><input type="checkbox" id="' +
                  tfdata.tfid +
                  '" style="cursor: pointer;" name="checkboxTFBH"' +
                  checkString +
                  "></td>" +
                  "<td>" +
                  tfdata.tfid +
                  "</td>" +
                  "<td>" +
                  tfdata.name +
                  "</td>" +
                  "<td>" +
                  tfdata.enname +
                  "</td>" +
                  "</tr>";
              }
              $("#typhoon_table_body tbody").html(html);
              $("#typhoon_div input:checkbox").click(function() {
                t.ischeck(this);
              });
              $("#" + firstTyphoonID).click();
            } else {
              html = '<tr><td colspan="4">暂无台风数据</td></tr>';
              $("#typhoon_table_body tbody").html(html);
            }
          } else {
            t.$Message.error({
              content: data.message,
              duration: 5
            });
          }
        }
      );
    },
    /**查询台风路径信息**/
    getTyphoonTrack: function(tfbh) {
      let t = this;
      $.get(this.$ipConfig.getTyphoonPathData + "&element=" + tfbh).then(
        data => {
          let trackData = data.dataList;
          t.allPointList = t.allPointList.concat(data.dataList);
          $("#typhoonText").html("");
          var html = "";
          if (trackData.length > 0) {
            var tfm = trackData[0].name;
            var title = tfm + "(" + tfbh + ")路径信息";
            $("#typhoonText").html(title);
            var trackDataIndex = trackData.length - 1; //用于台风路径信息表倒序显示
            for (var i = 0; i <= trackDataIndex; i++) {
              html +=
                '<tr class="track-data-index-show track-data-index-' +
                i +
                '"><td>' +
                moment(trackData[trackDataIndex - i].time).format(
                  "YYYY-MM-DD HH:mm:ss"
                ) +
                "</td><td>" +
                trackData[trackDataIndex - i].speed +
                '</td><td style="width:70px">' +
                t.getTyphoonLevel(trackData[trackDataIndex - i].speed) +
                "</td><td >" +
                trackData[trackDataIndex - i].movedirection +
                "</td></tr>"; //倒序列表
            }
            $("#typhoon_track_table_body tbody").html(html);
          }
          t.showTyphoonTMap(trackData, tfbh);
        }
      );
    },
    /**查询低压路径信息**/
    getTypthonnTrack: function(id, year) {
      let t = this;
      $.get(
        this.$ipConfig.host + "getHisLowTrackByID&thisid=" + id + "&time=" + year
      ).then(data => {
        let trackData = data.dataList.reverse();
        var html = "";
        if (trackData.length > 0) {
          var trackDataIndex = trackData.length - 1; //用于台风路径信息表倒序显示
          for (var i = 0; i <= trackDataIndex; i++) {
            html +=
              '<tr class="track-data-index-show track-data-index-' +
              i +
              '"><td>' +
              moment(trackData[trackDataIndex - i].time).format(
                "YYYY-MM-DD HH:mm:ss"
              ) +
              "</td><td>" +
              trackData[trackDataIndex - i].speed +
              '</td><td style="width:70px">' +
              t.getTyphoonLevel(trackData[trackDataIndex - i].speed) +
              "</td><td >" +
              trackData[trackDataIndex - i].movedirection +
              "</td></tr>"; //倒序列表
          }
          $("#typhoon_track_data3 tbody").html(html);
        }
        t.showTyphoonTMap(
          trackData,
          year + '_' + id
        );
      });
    },
    /**地图显示台风路径信息
     * @param  ｛array｝ ｛array｝｛string｝
     * 台风路径，预报路径，台风编号
     */
    showTyphoonTMap: function(trackData, tfbh) {
      let t = this;
      let typhoonPointList = [];
      //台风节点列表
      let animatorVector = new WeatherMap.Layer.AnimatorVector(
        "Metro",
        { rendererType: "StretchLine" },
        {
          repeat: false,
          //设置速度为每帧播放0.05的数据
          speed: 0.5,
          //开始时间为0
          startTime: 0,
          //每秒渲染12帧
          frameRate: 12,
          //结束时间设置为10
          endTime: 100
        }
      );
      animatorVector.events.on({ drawfeaturestart: t.drawfeaturestart });
      animatorVector.id = tfbh + "typhoonAnimator";
      t.map.addLayer(animatorVector);
      t.map.setLayerIndex(animatorVector, 1);
      var pointList = [];
      var fengPoint = new WeatherMap.Geometry.Point(
        trackData[trackData.length - 1].lng,
        trackData[trackData.length - 1].lat
      );
      var attribute = trackData[trackData.length - 1];
      attribute.type = "台风路径点";
      attribute.typhoonNum = trackData.length - 1;
      if(this.operation == 'diya'){
          attribute = trackData[0];
          fengPoint = new WeatherMap.Geometry.Point(
            trackData[0].lng,
            trackData[0].lat
          );
          attribute.typhoonNum = 0;
      }
      var typhoonlevel = t.getTyphoonInformation(attribute.speed);
      attribute.level = typhoonlevel.name;
      var fengPointVector = new WeatherMap.Feature.Vector(
        fengPoint,
        attribute,
        {
          externalGraphic: typhoonImg,
          pointRadius: 30,
          graphicOpacity: 0.9
        }
      );
      fengPointVector.id = tfbh + "feng";
      t.typhoonVectorList[fengPointVector.id] = fengPointVector;
      //   var yubaoList = list.typhoonPointList[list.typhoonPointList.length - 1];
      t.typhoonVectorList[tfbh + "yubao"] = trackData[trackData.length - 1];
      var lineFeatures = [];
      var pointAnimatorList = [];
      var lineVector;
      for (var i = 0; i < trackData.length; i++) {
        var arr = [];
        var point = new WeatherMap.Geometry.Point(
          trackData[i].lng,
          trackData[i].lat
        );
        pointList.push(point);
        var attribute = trackData[i];
        attribute.type = "台风路径点";
        attribute.typhoonNum = i;
        var typhoonlevel = t.getTyphoonInformation(attribute.speed);
        attribute.level = typhoonlevel.name;
        var pointVector = new WeatherMap.Feature.Vector(point, attribute);
        pointVector.id = tfbh + '' + trackData[i].time;
        pointVector.style = {
          fillColor: typhoonlevel.color,
          strokeWidth: 0.5,
          pointRadius: 5
        };
        var pointAnimator = new WeatherMap.Feature.Vector(
          point,
          {
            FEATUREID: 0,
            TIME: i
          },
          {
            externalGraphic: typhoonImg,
            pointRadius: 30,
            graphicOpacity: 0.9
          }
        );
        pointAnimatorList.push(pointAnimator);
        typhoonPointList.push(pointVector);
        // t.typhoonPointLayer.addFeatures([pointVector]);
        var line = new WeatherMap.Geometry.LineString(pointList);
        arr.push(line);
        var multiLineString = new WeatherMap.Geometry.MultiLineString(arr);
        lineVector = new WeatherMap.Feature.Vector(multiLineString, {
          FEATUREID: 1,
          TIME: i
        });
        lineVector.id = tfbh;
        lineVector.style = {
          strokeColor: "rgb(0,118,201)",
          strokeWidth: 2
        };
        if(this.operation == 'diya'){
          lineVector.style = {
            strokeColor: "rgb(0,118,201)",
            strokeWidth: 2,
            strokeDashstyle: "dash"
          };
        }
        lineFeatures.push(lineVector);
      }
      t.typhoonVectorList[tfbh + "line"] = lineVector;
      t.typhoonVectorList[tfbh] = typhoonPointList;
      //   showTyphoonInfoList(typhoonPointList);
      animatorVector.removeAllFeatures();
      animatorVector.addFeatures(lineFeatures);
      animatorVector.addFeatures(pointAnimatorList);
      animatorVector.animator.setStartTime(0);
      animatorVector.animator.setEndTime(lineFeatures.length);
      animatorVector.animator.setCurrentTime(0);
      animatorVector.animator.start();
      var locationPoint = new WeatherMap.LonLat(
        trackData[trackData.length - 1].lng,
        trackData[trackData.length - 1].lat
      );
      t.map.panTo(locationPoint);
      t.map.zoomTo(6);
    },
    //动画添加实况点和风圈
    drawfeaturestart(feature) {
      let t = this;
      if (feature.geometry.hasOwnProperty("components")) {
        var num = feature.geometry.components[0].components.length;
        var list = t.typhoonVectorList[feature.id];
        if (typeof list == "undefined") {
          return;
        }
        if (num < list.length) {
          if (t.typhoonPointLayer.getFeatureById(list[num - 1].id) == null)
            t.typhoonPointLayer.addFeatures([list[num - 1]]);
        } else if (num == list.length) {
          if (
            t.typhoonPointLayer.getFeatureById(list[list.length - 1].id) == null
          ) {
            t.typhoonPointLayer.addFeatures([list[list.length - 1]]);
            t.typhoonPointLayer.addFeatures([
              t.typhoonVectorList[feature.id + "feng"]
            ]);
            //添加最后一个点的预报数据
            t.typhoonLineLayer.addFeatures([
              t.typhoonVectorList[feature.id + "line"]
            ]);
            t.addTyphoonForcastdata(t.typhoonVectorList[feature.id + "yubao"]);
            var layer = t.map.getLayer(feature.id + "typhoonAnimator");
            if (layer != null) {
              t.map.removeLayer(layer);
            }
          }
        }
        t.typhoonVectorList["yubaoPoint"] = list[num - 1].attributes;
        t.showFengquan();
      }
    },
    //添加台风预报路径
    addTyphoonForcastdata(yubao) {
      let t = this;
      let yubaoList = {};
      if(!yubao.tfid) return;
      $.get(
          this.$ipConfig.getTyphoonForData + "&thisid=" + yubao.tfid
        ).then(data => {
          if (data.message === "查询成功") {
            data.dataList.map(item => {
            if (!yubaoList[item.forecastAddress]) {
                yubaoList[item.forecastAddress] = [];
                yubaoList[item.forecastAddress].push(yubao);
            }
            yubaoList[item.forecastAddress].push(item);
            });
            var point;
            t.typhoonVectorList[yubao.tfid + "yubaoPoints"] = [];
            t.typhoonVectorList[yubao.tfid + "yubaoLines"] = [];
            Object.keys(yubaoList).map(e => {
                let list = yubaoList[e];
                if (!$('input[value="' + e + '"]').is(":checked")) list = [];
                var pointList = [];
                for (var j = 0; j < list.length; j++) {
                if (j == 0 && list[j].lng != 9999) {
                    t.allPointList.map(item => {
                        if(item.currentId == list[1].currentId){
                            t.clickPoint = item;
                            point = new WeatherMap.Geometry.Point(item.lng, item.lat);
                        }
                    })
                    // point = new WeatherMap.Geometry.Point(yubao.lng, yubao.lat);
                } else {
                    if (j == 0) {
                      point = new WeatherMap.Geometry.Point(yubao.lng, yubao.lat);
                      pointList.push(point);
                    }
                    point = new WeatherMap.Geometry.Point(list[j].lng, list[j].lat);
                }
                if(t.clickPoint.time > list[j].time && j != 0) continue;
                pointList.push(point);
                var attribute = list[j];
                attribute.type = "台风预报点";
                if(j == 0) {
                    attribute.type = "台风路径点";
                }
                var pointVector = new WeatherMap.Feature.Vector(point, attribute);
                var color = t.getTyphoonPointColor(attribute.speed);
                pointVector.name = attribute.tfid;
                pointVector.style = {
                    fillColor: color,
                    strokeWidth: 0.5,
                    pointRadius: 5
                };
                t.typhoonYubaoPointLayer.addFeatures([pointVector]);
                t.typhoonVectorList[yubao.tfid + "yubaoPoints"] = t.typhoonVectorList[yubao.tfid + "yubaoPoints"].concat([pointVector]);
                }
                var line = new WeatherMap.Geometry.LineString(pointList);
                var lineVector = new WeatherMap.Feature.Vector(line);
                var lineColor = "red";
                if (list.length != 0) {
                  lineColor = t.getTyphoonYubaoLine(list[1].forecastAddress);
                }
                lineVector.style = {
                  strokeColor: lineColor,
                  strokeDashstyle: "dash",
                  strokeWidth: 2
                };
                lineVector.name = yubao.tfid;
                t.typhoonVectorList[yubao.tfid + "yubaoLines"] = t.typhoonVectorList[yubao.tfid + "yubaoLines"].concat([lineVector]);
                t.typhoonYubaoLineLayer.addFeatures([lineVector]);
            });
          } else {
            me.$Message.error({
              content: data.message,
              duration: 5
            });
          }
        });

    },
    //显示某个点的预报路径
    addForcastData(attributes) {
      let t = this;
      t.clickPoint = attributes;
      $.get(
        this.$ipConfig.getLastTypthoonForData +
          "&thisid=" +
          attributes.currentId
      ).then(data => {
        t.typhoonYubaoPointLayer.removeFeatures(t.typhoonVectorList[attributes.tfid + "yubaoPoints"]);
        t.typhoonYubaoLineLayer.removeFeatures(t.typhoonVectorList[attributes.tfid + "yubaoLines"]);
        t.ybList = data.dataList;
        t.addTyphoonForcastdata2(attributes);
      });
    },
    //添加台风预报路径
    addTyphoonForcastdata2(yubao) {
      let t = this;
      let yubaoList = {};
      t.ybList.map(item => {
        if (!yubaoList[item.forecastAddress]) {
          yubaoList[item.forecastAddress] = [];
          yubaoList[item.forecastAddress].push(yubao);
        }
        yubaoList[item.forecastAddress].push(item);
      });
      var point;
      t.typhoonVectorList[yubao.tfid + "yubaoPoints"] = [];
      t.typhoonVectorList[yubao.tfid + "yubaoLines"] = [];
      Object.keys(yubaoList).map(e => {
        let list = yubaoList[e];
        if (!$('input[value="' + e + '"]').is(":checked")) list = [];
        var pointList = [];
        for (var j = 0; j < list.length; j++) {
          if (j == 0 && list[j].lng != 9999) {
            point = new WeatherMap.Geometry.Point(yubao.lng, yubao.lat);
          } else {
            if (j == 0) {
              point = new WeatherMap.Geometry.Point(yubao.lng, yubao.lat);
              pointList.push(point);
            }
            point = new WeatherMap.Geometry.Point(list[j].lng, list[j].lat);
          }
          if(yubao.time > list[j].time && j != 0) continue;
          pointList.push(point);
          var attribute = list[j];
          attribute.type = "台风预报点";
          if(j == 0) {
            attribute.type = "台风路径点";
          }
          var pointVector = new WeatherMap.Feature.Vector(point, attribute);
          var color = t.getTyphoonPointColor(attribute.speed);
          pointVector.name = attribute.tfid;
          pointVector.style = {
            fillColor: color,
            strokeWidth: 0.5,
            pointRadius: 5
          };
          t.typhoonYubaoPointLayer.addFeatures([pointVector]);
          t.typhoonVectorList[yubao.tfid + "yubaoPoints"] = t.typhoonVectorList[yubao.tfid + "yubaoPoints"].concat([pointVector]);
        }
        var line = new WeatherMap.Geometry.LineString(pointList);
        var lineVector = new WeatherMap.Feature.Vector(line);
        var lineColor = "red";
        if (list.length != 0) {
          lineColor = t.getTyphoonYubaoLine(list[1].forecastAddress);
        }
        lineVector.style = {
          strokeColor: lineColor,
          strokeDashstyle: "dash",
          strokeWidth: 2
        };
        lineVector.name = yubao.tfid;
        t.typhoonYubaoLineLayer.addFeatures([lineVector]);
        t.typhoonVectorList[yubao.tfid + "yubaoLines"] = t.typhoonVectorList[yubao.tfid + "yubaoLines"].concat([lineVector]);
      });
    },
    //显示风圈
    showFengquan(obj) {
      let t = this;
      t.typhoonFengquanLayer.removeAllFeatures();
      //   if (obj.checked == true) {
      if (typeof t.typhoonVectorList["yubaoPoint"] != "undefined") {
        var yubaoPoint = t.typhoonVectorList["yubaoPoint"];
        //圆
        if (yubaoPoint.en7radii != null) {
          var centerPoint = new WeatherMap.Geometry.Point(
            yubaoPoint.lng,
            yubaoPoint.lat
          );
          var radius = yubaoPoint.en7radii / 110;
          var circleP = t.createCircle(centerPoint, radius, 64, 270, 90);
          var circleVector = new WeatherMap.Feature.Vector(circleP);
          circleVector.style = {
            strokeColor: "rgb(224,172,82)",
            fillColor: "rgb(224,172,82)",
            // strokeWidth: 1,
            fillOpacity: 0.4,
            stroke: false
          };
          t.typhoonFengquanLayer.addFeatures([circleVector]);
        }
        if (yubaoPoint.es7radii != null) {
          var centerPoint = new WeatherMap.Geometry.Point(
            yubaoPoint.lng,
            yubaoPoint.lat
          );
          var radius = yubaoPoint.es7radii / 110;
          var circleP = t.createCircle(centerPoint, radius, 64, 180, 90);
          var circleVector = new WeatherMap.Feature.Vector(circleP);
          circleVector.style = {
            strokeColor: "rgb(224,172,82)",
            fillColor: "rgb(224,172,82)",
            strokeWidth: 1,
            fillOpacity: 0.4,
            stroke: false
          };
          t.typhoonFengquanLayer.addFeatures([circleVector]);
        }
        if (yubaoPoint.ws7radii != null) {
          var centerPoint = new WeatherMap.Geometry.Point(
            yubaoPoint.lng,
            yubaoPoint.lat
          );
          var radius = yubaoPoint.ws7radii / 110;
          var circleP = t.createCircle(centerPoint, radius, 64, 90, 90);
          var circleVector = new WeatherMap.Feature.Vector(circleP);
          circleVector.style = {
            strokeColor: "rgb(224,172,82)",
            fillColor: "rgb(224,172,82)",
            strokeWidth: 1,
            fillOpacity: 0.4,
            stroke: false
          };
          t.typhoonFengquanLayer.addFeatures([circleVector]);
        }
        if (yubaoPoint.wn7radii != null) {
          var centerPoint = new WeatherMap.Geometry.Point(
            yubaoPoint.lng,
            yubaoPoint.lat
          );
          var radius = yubaoPoint.wn7radii / 110;
          var circleP = t.createCircle(centerPoint, radius, 64, 0, 90);
          var circleVector = new WeatherMap.Feature.Vector(circleP);
          circleVector.style = {
            strokeColor: "rgb(224,172,82)",
            fillColor: "rgb(224,172,82)",
            strokeWidth: 1,
            fillOpacity: 0.4,
            stroke: false
          };
          t.typhoonFengquanLayer.addFeatures([circleVector]);
        }
        //圆
        if (yubaoPoint.en10radii != null) {
          var centerPoint = new WeatherMap.Geometry.Point(
            yubaoPoint.lng,
            yubaoPoint.lat
          );
          var radius = yubaoPoint.en10radii / 110;
          var circleP = t.createCircle(centerPoint, radius, 64, 270, 90);
          var circleVector = new WeatherMap.Feature.Vector(circleP);
          circleVector.style = {
            strokeColor: "rgb(224,172,82)",
            fillColor: "rgb(224,172,82)",
            // strokeWidth: 1,
            fillOpacity: 0.4,
            stroke: false
          };
          t.typhoonFengquanLayer.addFeatures([circleVector]);
        }
        if (yubaoPoint.es10radii != null) {
          var centerPoint = new WeatherMap.Geometry.Point(
            yubaoPoint.lng,
            yubaoPoint.lat
          );
          var radius = yubaoPoint.es10radii / 110;
          var circleP = t.createCircle(centerPoint, radius, 64, 180, 90);
          var circleVector = new WeatherMap.Feature.Vector(circleP);
          circleVector.style = {
            strokeColor: "rgb(224,172,82)",
            fillColor: "rgb(224,172,82)",
            strokeWidth: 1,
            fillOpacity: 0.4,
            stroke: false
          };
          t.typhoonFengquanLayer.addFeatures([circleVector]);
        }
        if (yubaoPoint.ws10radii != null) {
          var centerPoint = new WeatherMap.Geometry.Point(
            yubaoPoint.lng,
            yubaoPoint.lat
          );
          var radius = yubaoPoint.ws10radii / 110;
          var circleP = t.createCircle(centerPoint, radius, 64, 90, 90);
          var circleVector = new WeatherMap.Feature.Vector(circleP);
          circleVector.style = {
            strokeColor: "rgb(224,172,82)",
            fillColor: "rgb(224,172,82)",
            strokeWidth: 1,
            fillOpacity: 0.4,
            stroke: false
          };
          t.typhoonFengquanLayer.addFeatures([circleVector]);
        }
        if (yubaoPoint.wn10radii != null) {
          var centerPoint = new WeatherMap.Geometry.Point(
            yubaoPoint.lng,
            yubaoPoint.lat
          );
          var radius = yubaoPoint.wn10radii / 110;
          var circleP = t.createCircle(centerPoint, radius, 64, 0, 90);
          var circleVector = new WeatherMap.Feature.Vector(circleP);
          circleVector.style = {
            strokeColor: "rgb(224,172,82)",
            fillColor: "rgb(224,172,82)",
            strokeWidth: 1,
            fillOpacity: 0.4,
            stroke: false
          };
          t.typhoonFengquanLayer.addFeatures([circleVector]);
        }
      }
      //   } else {
      //     t.typhoonFengquanLayer.removeAllFeatures();
      //   }
    },
    //圆
    createCircle(origin, radius, sides, r, angel) {
      var rR = (90 * Math.PI) / (180 * sides);
      var rotatedAngle, x, y;
      var points = [];
      for (var i = 0; i < sides; ++i) {
        rotatedAngle = (r * Math.PI) / 180 + rR * i;
        x = origin.x + radius * Math.cos(rotatedAngle);
        y = origin.y + radius * Math.sin(rotatedAngle);
        points.push(new WeatherMap.Geometry.Point(x, y));
      }
      rotatedAngle = ((r + 90) * Math.PI) / 180;
      x = origin.x + radius * Math.cos(rotatedAngle);
      y = origin.y + radius * Math.sin(rotatedAngle);
      points.push(new WeatherMap.Geometry.Point(x, y));
      points.push(origin);

      var ring = new WeatherMap.Geometry.LinearRing(points);
      ring.rotate(parseFloat(angel), origin);
      var geo = new WeatherMap.Geometry.Collection([ring]);
      geo.origin = origin;
      geo.radius = radius;
      geo.r = r;
      geo.angel = angel;
      geo.sides = sides;
      geo.polygonType = "Curve";
      return geo;
    },
    getTyphoonPointColor(speed) {
      var color;
      if (speed > 51.0) color = "rgb(219,0,0)";
      else if (speed >= 42.5 && speed < 51.0) color = "rgb(255,0,255)";
      else if (speed >= 32.7 && speed < 42.5) color = "rgb(255,117,0)";
      else if (speed >= 24.5 && speed < 32.7) color = "rgb(255,255,0)";
      else if (speed >= 17.2 && speed < 24.5) color = "rgb(64,151,239)";
      else if (speed < 17.2) color = "rgb(0,141,0)";
      return color;
    },
    getTyphoonYubaoLine(value) {
      if (value == "中国") {
        return "#FF6450";
      } else if (value == "日本") {
        return "#43FF4B";
      } else if (value == "美国") {
        return "#40DDFF";
      } else if (value == "中国台湾") {
        return "#FFA040";
      } else if (value == "中国香港") {
        return "#FF66FF";
      } else if (value == "欧洲") {
        return "#373591";
      } else if (value == "韩国") {
        return "#669999";
      } else {
        return "red";
      }
    },
    getTyphoonInformation(speed) {
      var color;
      var name;
      if (speed > 51.0) {
        color = "rgb(219,0,0)";
        name = "超强台风";
      } else if (speed >= 42.5 && speed < 51.0) {
        color = "rgb(255,0,255)";
        name = "强台风";
      } else if (speed >= 32.7 && speed < 42.5) {
        color = "rgb(255,117,0)";
        name = "台风";
      } else if (speed >= 24.5 && speed < 32.7) {
        color = "rgb(255,255,0)";
        name = "强热带风暴";
      } else if (speed >= 17.2 && speed < 24.5) {
        color = "rgb(64,151,239)";
        name = "热带风暴";
      } else if (speed < 17.2) {
        color = "rgb(0,141,0)";
        name = "热带低压";
      }
      return { color: color, name: name };
    },
    /**获取台风等级**/
    getTyphoonLevel: function(windSpeed) {
      var level = "";
      var speed = Number(windSpeed);
      if (speed >= 10.8 && speed <= 17.1) {
        level = "热带低压";
      } else {
        if (speed >= 17.2 && speed <= 24.4) {
          level = "热带风暴";
        } else {
          if (speed >= 24.5 && speed <= 32.6) {
            level = "强热带风暴";
          } else {
            if (speed >= 32.7 && speed <= 41.4) {
              level = "台风";
            } else {
              if (speed >= 41.5 && speed <= 50.9) {
                level = "强台风";
              } else {
                if (speed >= 51) {
                  level = "超强台风";
                } else {
                  level = "热带低压";
                }
              }
            }
          }
        }
      }
      return level;
    },
    /**是否勾选**/
    ischeck: function(e) {
      let t = this;
      var tfbh = $(e).attr("id");
      if (e.checked) {
        t.getTyphoonTrack(tfbh);
      } else {
        //清除轨迹信息
        $("#typhoon_track_table_body tbody").html("");
        t.clearGraphicById(tfbh);
      }
    },
    /**是否勾选**/
    ischeck2: function(e) {
      let t = this;
      var name = $(e).attr("id");
      var year = name.split('_')[0];
      var id = name.split('_')[1];
      $("#typhoon_track_table_body tbody").html("");
      t.clearTyphoonGra();
      t.getTypthonnTrack(id, year);
    },
    /**清空所有台风graphic**/
    clearTyphoonGra: function() {
      let t = this;
      t.typhoonPointLayer.removeAllFeatures();
      t.typhoonLineLayer.removeAllFeatures();
      t.typhoonFengquanLayer.removeAllFeatures();
      t.typhoonYubaoPointLayer.removeAllFeatures();
      t.typhoonYubaoLineLayer.removeAllFeatures();
    },
    /**根据ID清空台风图层**/
    clearGraphicById: function(id) {
      let t = this;
      t.typhoonPointLayer.removeFeatures(t.typhoonVectorList[id]);
      t.typhoonPointLayer.removeFeatures([t.typhoonVectorList[id + "feng"]]);
      t.typhoonLineLayer.removeFeatures([t.typhoonVectorList[id + "line"]]);
    //   if (id == t.ybList[0].tfid) {
        // t.typhoonYubaoPointLayer.removeAllFeatures();
        // t.typhoonYubaoLineLayer.removeAllFeatures();

        t.typhoonYubaoPointLayer.removeFeatures(t.typhoonVectorList[id + "yubaoPoints"]);
        t.typhoonVectorList[id + "yubaoPoints"] = [];
        t.typhoonYubaoLineLayer.removeFeatures(t.typhoonVectorList[id + "yubaoLines"]);
        t.typhoonVectorList[id + "yubaoLines"] = [];
    //   }
      t.typhoonFengquanLayer.removeAllFeatures();
    },
    addMyInfoWindow(attrs) {
      let t = this;
      let data = attrs.attributes;
      let lonLat = new WeatherMap.LonLat(data.lng, data.lat);
      let pixel = this.map.getPixelFromLonLat(lonLat);
      var html = '<div style="height:80px">';
      if (t.operation == "diya") {
        html +=
          '<div style="font-size:14px;margin-bottom:3px;color:black">低压' +
          "</div>";
      } else {
        if (data.name == undefined) {
          html +=
            '<div style="font-size:14px;margin-bottom:3px;color:black">预报台：' +
            data.forecastAddress +
            "(" +
            data.tfid +
            ")</div>";
        } else {
          html +=
            '<div style="font-size:14px;margin-bottom:3px;color:black">台风名称：' +
            data.name +
            "(" +
            data.tfid +
            ")</div>";
        }
      }

      html +=
        '<div style="font-size:14px;margin-bottom:3px;color:black">到达时间：' +
        moment(data.time).format("YYYY-MM-DD HH:mm:ss") +
        "</div>";
      html +=
        '<div style="font-size:14px;margin-bottom:3px;color:black;margin-top:4px">经度：' +
        data.lng.toFixed(2) +
        "</div>";
      html +=
        '<div style="font-size:14px;margin-bottom:3px;color:black;margin-top:4px">纬度：' +
        data.lat.toFixed(2) +
        "</div>";
      html +=
        '<div style="font-size:14px;margin-bottom:3px;color:black;margin-top:4px">最大风速：' +
        Number(data.speed).toFixed(1) +
        "米/秒--" +
        this.getTyphoonLevel(data.speed) +
        "</div>";
      html +=
        '<div style="font-size:14px;margin-bottom:3px;color:black;margin-top:4px">中心气压：' +
        data.pressure +
        "百帕</div>";
      html +=
        '<div style="font-size:14px;margin-bottom:3px;color:black;margin-top:4px">移动速度：' +
        Number(data.movespeed).toFixed(2) +
        "公里/小时</div>";
      html +=
        '<div style="font-size:14px;margin-bottom:3px;color:black;margin-top:4px">移动方向：' +
        data.movedirection +
        "</div>";
      if (t.operation == "taifeng") {
        html +=
          '<div style="font-size:14px;margin-bottom:3px;color:black;margin-top:4px">七级风圈半径：' +
          Number(data.radius7) +
          "公里</div>";
        html +=
          '<div style="font-size:14px;color:black;margin-top:4px">十级风圈半径：' +
          Number(data.radius10) +
          "公里</div>";
        html += "</div>";
      }

      let popwin = new WeatherMap.Popup.FramedCloud(
        "rainInfos",
        lonLat,
        new WeatherMap.Size(0, 0),
        html,
        null,
        true,
        null
      );
      popwin.setOpacity(0.0);
      t.map.removeAllPopup();
      t.map.addPopup(popwin);
    },
    addMyInfoWindow2(attrs) {
      let t = this;
      let data = attrs.attributes;
      let lonLat = new WeatherMap.LonLat(data.lng, data.lat);
      let pixel = this.map.getPixelFromLonLat(lonLat);
      var html = '<div style="height:80px">';
      if (t.operation == "diya") {
        html +=
          '<div style="font-size:14px;margin-bottom:3px;color:black">低压' +
          "</div>";
      } else {
        if (data.name == undefined) {
          html +=
            '<div style="font-size:14px;margin-bottom:3px;color:black">预报台：' +
            data.forecastAddress +
            "(" +
            data.tfid +
            ")</div>";
        } else {
          html +=
            '<div style="font-size:14px;margin-bottom:3px;color:black">台风名称：' +
            data.name +
            "(" +
            data.tfid +
            ")</div>";
        }
      }

      html +=
        '<div style="font-size:14px;margin-bottom:3px;color:black">到达时间：' +
        moment(data.time).format("YYYY-MM-DD HH:mm:ss") +
        "</div>";
      html +=
        '<div style="font-size:14px;margin-bottom:3px;color:black;margin-top:4px">经度：' +
        data.lng.toFixed(2) +
        "</div>";
      html +=
        '<div style="font-size:14px;margin-bottom:3px;color:black;margin-top:4px">纬度：' +
        data.lat.toFixed(2) +
        "</div>";
      html +=
        '<div style="font-size:14px;margin-bottom:3px;color:black;margin-top:4px">最大风速：' +
        data.speed +
        "米/秒--" +
        this.getTyphoonLevel(data.speed) +
        "</div>";
      html +=
        '<div style="font-size:14px;margin-bottom:3px;color:black;margin-top:4px">中心气压：' +
        data.pressure +
        "百帕</div>";
      html +=
        '<div style="font-size:14px;margin-bottom:3px;color:black;margin-top:4px">移动速度：' +
        Number(data.movespeed).toFixed(2) +
        "公里/小时</div>";
      html +=
        '<div style="font-size:14px;margin-bottom:3px;color:black;margin-top:4px">移动方向：' +
        data.movedirection +
        "</div>";
      if (t.operation == "taifeng") {
        html +=
          '<div style="font-size:14px;margin-bottom:3px;color:black;margin-top:4px">七级风圈半径：' +
          Number(data.radius7) +
          "公里</div>";
        html +=
          '<div style="font-size:14px;color:black;margin-top:4px">十级风圈半径：' +
          Number(data.radius10) +
          "公里</div>";
        html += "</div>";
      }

      let popwin = new WeatherMap.Popup.FramedCloud(
        "rainInfos",
        lonLat,
        new WeatherMap.Size(0, 0),
        html,
        null,
        true,
        null
      );
      popwin.setOpacity(0.0);
      t.map2.removeAllPopup();
      t.map2.addPopup(popwin);
    },
    exportImg() {
      let t = this;
      t.RemoveControl(
        document.getElementsByClassName("bubble_tooltip_textarea")
      );
      t.RemoveControl2(
        document.getElementsByClassName("bubble_tooltip_textarea2")
      );
      let fileName = "台风产品";
      let container = document.getElementsByClassName("product")[0];
      html2canvas(container, {
        backgroundColor: null,
        allowTaint: false,
        taintTest: false,
        letterRendering: true,
        logging: false,
        useCORS: true
      }).then(canvas => {
        var imgData = canvas.toDataURL("image/jpeg");
        t.fileDownload(imgData, fileName);
      });
    },
    //下载图片
    fileDownload(downloadUrl, fileName) {
      let aLink = document.createElement("a");
      aLink.style.display = "none";
      aLink.href = downloadUrl;
      aLink.download = fileName;
      // 触发点击-然后移除
      document.body.appendChild(aLink);
      aLink.click();
      document.body.removeChild(aLink);
    },
    showToolTip(currentFeature) {
      let t = this;
      var attrs = currentFeature.attributes;
      var lonLat;
      lonLat = new WeatherMap.LonLat(attrs.lng, attrs.lat);
      var pixel = t.map2.getPixelFromLonLat(lonLat);
      let id = "bubble_tooltip" + attrs.time + attrs.forecastAddress;
      let id2 = "bubble_tooltip_content" + attrs.time + attrs.forecastAddress;
      let className, className2;
      if (t.recordList.includes(id)) {
        $("#" + id).remove();
        for (var i = 0; i < t.recordList.length; i++) {
          if (t.recordList[i] == id) {
            t.recordList.splice(i, 1);
            t.recordLonLat.splice(i, 1);
            t.recordidNum.splice(i, 1);
          }
        }
      } else {
        t.recordList.push(id);
        t.recordLonLat.push(lonLat);
        t.recordidNum.push(t.idNum);
        switch (t.idNum) {
          case 0:
            className = "triRight";
            className2 = "triRightInner";
            break;
          case 1:
            className = "triLeft";
            className2 = "trileftInner";
            break;
          case 2:
            className = "triTop";
            className2 = "triTopInner";
            break;
          case 3:
            className = "triBtm";
            className2 = "triBtmInner";
            break;
          case 4:
            className = "triLeftTop";
            className2 = "trileftTopInner";
            break;
          case 5:
            className = "triLeftBtm";
            className2 = "trileftBtmInner";
            break;
          case 6:
            className = "triRightTop";
            className2 = "triRightTopInner";
            break;
          case 7:
            className = "triRightBtm";
            className2 = "triRightBtmInner";
            break;
        }
        var html = `<div class="bubble_tooltip_common" id="${id}">
            <label class="${className}"></label> <label class="${className2}"></label>
            <div class="ivu-input-wrapper ivu-input-wrapper-default ivu-input-type-textarea" id="${id2}">
            <textarea wrap="soft" autocomplete="off" spellcheck="false" placeholder="Enter something..." rows="2" class="ivu-input bubble_tooltip_textarea" style="height: 71px; min-height: 50px; max-height: 113px; overflow-y: hidden;">${moment(
              attrs.time
            ).format("MM月DD日HH时")}\n${Number(attrs.speed).toFixed(
          1
        )}米/秒\n${t.getTyphoonInformation(attrs.speed).name}</textarea>
            </div>
            </div>`;
        $(".product .mid").append(html);
        var obj = document.getElementById(id);
        var st = Math.max(
          document.body.scrollTop,
          document.documentElement.scrollTop
        );
        if (this.idNum == 0) {
          if (navigator.userAgent.toLowerCase().indexOf("safari") >= 0) st = 0;
          var leftPos = pixel.x + 72; //clientX 事件属性返回当事件被触发时鼠标指针相对于浏览器页面（或客户区）的水平坐标
          if (leftPos < 0) leftPos = 0;
          obj.style.left = leftPos + "px";
          obj.style.top = pixel.y + st + 10 + "px";
          obj.style.display = "block";
        } else if (this.idNum == 1) {
          if (navigator.userAgent.toLowerCase().indexOf("safari") >= 0) st = 0;
          var leftPos = pixel.x - 196; //clientX 事件属性返回当事件被触发时鼠标指针相对于浏览器页面（或客户区）的水平坐标
          if (leftPos < 0) leftPos = 0;
          obj.style.left = leftPos + "px";
          obj.style.top = pixel.y + st + 10 + "px";
          obj.style.display = "block";
        } else if (this.idNum == 2) {
          if (navigator.userAgent.toLowerCase().indexOf("safari") >= 0) st = 0;
          var leftPos = pixel.x - 47; //clientX 事件属性返回当事件被触发时鼠标指针相对于浏览器页面（或客户区）的水平坐标
          if (leftPos < 0) leftPos = 0;
          obj.style.left = leftPos + "px";
          obj.style.top = pixel.y + st + 112 + "px";
          obj.style.display = "block";
        } else if (this.idNum == 3) {
          if (navigator.userAgent.toLowerCase().indexOf("safari") >= 0) st = 0;
          var leftPos = pixel.x - 47; //clientX 事件属性返回当事件被触发时鼠标指针相对于浏览器页面（或客户区）的水平坐标
          if (leftPos < 0) leftPos = 0;
          obj.style.left = leftPos + "px";
          obj.style.top = pixel.y + st - 115 + "px";
          obj.style.display = "block";
        }else if (this.idNum == 4) {
          if (navigator.userAgent.toLowerCase().indexOf("safari") >= 0) st = 0;
          var leftPos = pixel.x - 166; //clientX 事件属性返回当事件被触发时鼠标指针相对于浏览器页面（或客户区）的水平坐标
          if (leftPos < 0) leftPos = 0;
          obj.style.left = leftPos + "px";
          obj.style.top = pixel.y + st - 86 + "px";
          obj.style.display = "block";
        }else if (this.idNum == 5) {
          if (navigator.userAgent.toLowerCase().indexOf("safari") >= 0) st = 0;
          var leftPos = pixel.x - 166; //clientX 事件属性返回当事件被触发时鼠标指针相对于浏览器页面（或客户区）的水平坐标
          if (leftPos < 0) leftPos = 0;
          obj.style.left = leftPos + "px";
          obj.style.top = pixel.y + st + 85 + "px";
          obj.style.display = "block";
        }else if (this.idNum == 6) {
          if (navigator.userAgent.toLowerCase().indexOf("safari") >= 0) st = 0;
          var leftPos = pixel.x + 49; //clientX 事件属性返回当事件被触发时鼠标指针相对于浏览器页面（或客户区）的水平坐标
          if (leftPos < 0) leftPos = 0;
          obj.style.left = leftPos + "px";
          obj.style.top = pixel.y + st + 87 + "px";
          obj.style.display = "block";
        }else if (this.idNum == 7) {
          if (navigator.userAgent.toLowerCase().indexOf("safari") >= 0) st = 0;
          var leftPos = pixel.x + 49; //clientX 事件属性返回当事件被触发时鼠标指针相对于浏览器页面（或客户区）的水平坐标
          if (leftPos < 0) leftPos = 0;
          obj.style.left = leftPos + "px";
          obj.style.top = pixel.y + st - 88 + "px";
          obj.style.display = "block";
        }

        t.map2.events.register("move", t.map2, function(event) {
          t.recordList.map((item, index) => {
            var obj = document.getElementById(item);
            var st = Math.max(
              document.body.scrollTop,
              document.documentElement.scrollTop
            );
            let pixel = t.map2.getPixelFromLonLat(t.recordLonLat[index]);
            if (t.recordidNum[index] == 0) {
              if (navigator.userAgent.toLowerCase().indexOf("safari") >= 0)
                st = 0;
              var leftPos = pixel.x + 72; //clientX 事件属性返回当事件被触发时鼠标指针相对于浏览器页面（或客户区）的水平坐标
              if (leftPos < 0) leftPos = 0;
              obj.style.left = leftPos + "px";
              obj.style.top = pixel.y + st + 10 + "px";
              obj.style.display = "block";
            } else if (t.recordidNum[index] == 1) {
              if (navigator.userAgent.toLowerCase().indexOf("safari") >= 0)
                st = 0;
              var leftPos = pixel.x - 196; //clientX 事件属性返回当事件被触发时鼠标指针相对于浏览器页面（或客户区）的水平坐标
              if (leftPos < 0) leftPos = 0;
              obj.style.left = leftPos + "px";
              obj.style.top = pixel.y + st + 10 + "px";
              obj.style.display = "block";
            } else if (t.recordidNum[index] == 2) {
              if (navigator.userAgent.toLowerCase().indexOf("safari") >= 0)
                st = 0;
              var leftPos = pixel.x - 47; //clientX 事件属性返回当事件被触发时鼠标指针相对于浏览器页面（或客户区）的水平坐标
              if (leftPos < 0) leftPos = 0;
              obj.style.left = leftPos + "px";
              obj.style.top = pixel.y + st + 112 + "px";
              obj.style.display = "block";
            } else if (t.recordidNum[index] == 3) {
              if (navigator.userAgent.toLowerCase().indexOf("safari") >= 0)
                st = 0;
              var leftPos = pixel.x - 47; //clientX 事件属性返回当事件被触发时鼠标指针相对于浏览器页面（或客户区）的水平坐标
              if (leftPos < 0) leftPos = 0;
              obj.style.left = leftPos + "px";
              obj.style.top = pixel.y + st - 115 + "px";
              obj.style.display = "block";
            }else if (t.recordidNum[index] == 4) {
              if (navigator.userAgent.toLowerCase().indexOf("safari") >= 0)
                st = 0;
              var leftPos = pixel.x - 166; //clientX 事件属性返回当事件被触发时鼠标指针相对于浏览器页面（或客户区）的水平坐标
              if (leftPos < 0) leftPos = 0;
              obj.style.left = leftPos + "px";
              obj.style.top = pixel.y + st - 86 + "px";
              obj.style.display = "block";
            }else if (t.recordidNum[index] == 5) {
              if (navigator.userAgent.toLowerCase().indexOf("safari") >= 0)
                st = 0;
              var leftPos = pixel.x - 166; //clientX 事件属性返回当事件被触发时鼠标指针相对于浏览器页面（或客户区）的水平坐标
              if (leftPos < 0) leftPos = 0;
              obj.style.left = leftPos + "px";
              obj.style.top = pixel.y + st + 85 + "px";
              obj.style.display = "block";
            }else if (t.recordidNum[index] == 6) {
              if (navigator.userAgent.toLowerCase().indexOf("safari") >= 0)
                st = 0;
              var leftPos = pixel.x + 49; //clientX 事件属性返回当事件被触发时鼠标指针相对于浏览器页面（或客户区）的水平坐标
              if (leftPos < 0) leftPos = 0;
              obj.style.left = leftPos + "px";
              obj.style.top = pixel.y + st + 87 + "px";
              obj.style.display = "block";
            }else if (t.recordidNum[index] == 7) {
              if (navigator.userAgent.toLowerCase().indexOf("safari") >= 0)
                st = 0;
              var leftPos = pixel.x + 49; //clientX 事件属性返回当事件被触发时鼠标指针相对于浏览器页面（或客户区）的水平坐标
              if (leftPos < 0) leftPos = 0;
              obj.style.left = leftPos + "px";
              obj.style.top = pixel.y + st - 88 + "px";
              obj.style.display = "block";
            }
          });
        });
      }
    },
    move(id) {
      //获取元素
      var dv = document.getElementById(id);
      var x = 0;
      var y = 0;
      var l = 0;
      var t = 0;
      var isDown = false;
      //鼠标按下事件
      dv.onmousedown = function(e) {
        //获取x坐标和y坐标
        x = e.clientX;
        y = e.clientY;

        //获取左部和顶部的偏移量
        l = dv.offsetLeft;
        t = dv.offsetTop;
        //开关打开
        isDown = true;
        //设置样式
        dv.style.cursor = "move";
      };
      //鼠标移动
      window.onmousemove = function(e) {
        if (isDown == false) {
          return;
        }
        //获取x和y
        var nx = e.clientX;
        var ny = e.clientY;
        //计算移动后的左偏移量和顶部的偏移量
        var nl = nx - (x - l);
        var nt = ny - (y - t);

        dv.style.left = nl + "px";
        dv.style.top = nt + "px";
      };
      //鼠标抬起事件
      dv.onmouseup = function() {
        //开关关闭
        isDown = false;
        dv.style.cursor = "default";
      };
    },
    RemoveControl(elements) {
      var arrObj = new Array();
      var count = elements.length;
      for (var i = 0; i < count; i++) {
        if (elements[i] == undefined) continue;
        var obj = document.createElement("span");
        switch (elements[i].type) {
          case "text":
            obj.setAttribute("innerHTML", elements[i].value);
            break;
          case "textarea":
            obj.innerHTML = elements[i].value;
            obj.style["white-space"] = "pre";
            elements[i].value = "";
            break;
          case "select-one":
            for (var j = 0; j < elements[i].length; j++) {
              if (elements[i][j].selected) {
                obj.setAttribute("innerHTML", elements[i][j].text);
                break;
              }
            }
            elements[i].options.length = 0;
            break;
        }
        elements[i].parentNode.appendChild(obj);
        arrObj[arrObj.length] = elements[i];
      }

      //删除表单原控件
      for (var i = 0; i < arrObj.length; i++) {
        arrObj[i].remove();
      }
    },
    RemoveControl2(elements) {
      var arrObj = new Array();
      var count = elements.length;
      for (var i = 0; i < count; i++) {
        if (elements[i] == undefined) continue;
        var obj = document.createElement("span");
        let node;
        if(elements[i].children[1] != undefined) {
            node = elements[i].children[1]
        }else{
            node = elements[i].children[0]
        }
        obj.innerHTML = node.value;
        // obj.style["white-space"] = "pre";
        obj.style["font-size"] = "20px";
        obj.style["margin-left"] = "20px";
        node.value = "";
        elements[i].parentNode.appendChild(obj);
        arrObj[arrObj.length] = elements[i];
      }

      //删除表单原控件
      for (var i = 0; i < arrObj.length; i++) {
        arrObj[i].remove();
      }
    },
    change(e) {
      this.idNum = e;
    },
    //计算距离
    getDistance(geoRegion){
        var measureParam = new WeatherMap.REST.MeasureParameters(geoRegion);
        var pointsArr = new Array();
        pointsArr = geoRegion.components;
        var distance = 0;
        var len = pointsArr.length;
        if(len > 2){
            var p1;
            var p2;
            for(var i=0; i<len-1; i=i+1)
            {
                p1 = pointsArr[i];
                p2 = pointsArr[i+1];
                var radLat1 = this.rad(p1.y);
                var radLat2 = this.rad(p2.y);
                var a = radLat1 - radLat2;
                var b = this.rad(p1.x) - this.rad(p2.x);
                var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a/2),2) +
                        Math.cos(radLat1)*Math.cos(radLat2)*Math.pow(Math.sin(b/2),2)));
                distance += s;
            }
            distance = distance * 6378137.0;
        }else{
            p1 = pointsArr[len-1];
            p2 = pointsArr[0];
            var radLat1 = this.rad(p1.y);
            var radLat2 = this.rad(p2.y);
            var a = radLat1 - radLat2;
            var b = this.rad(p1.x) - this.rad(p2.x);
            var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a/2),2) +
                    Math.cos(radLat1)*Math.cos(radLat2)*Math.pow(Math.sin(b/2),2)));
            distance = s * 6378137.0;
        }
        distance = Math.abs(distance);
        var disStr = "";
        if(distance<1000){
            disStr = Number(distance).toFixed(0) + " 米";
        }else{
            disStr = Number(distance/1000).toFixed(3) + " 千米";
        }
        return disStr;
    },
    startDraw() {
      this.dxdrawLine.activate();
    },
    clearDraw() {
      this.dxdrawLine.deactivate();
      this.dxdrawLayer.removeAllFeatures();
      this.dxlineLayer.removeAllFeatures();
    },
    degtoRad(val){
        return val*Math.PI/180;
    },
    rad(d)
    {
      return d * Math.PI / 180.0;
    }
  },
  created() {
    // this.initMap();
  }
};
</script>
<style scoped>
.mapPage {
  width: 100%;
  height: 97%;
}
</style>



// WEBPACK FOOTER //
// src/components/pc/huananForecast.vue